// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-14T20:31:14.951Z
// Property: Regatta (ID: 6767906449166401)
// Collections: 36 amenities, 7 floorplans (live), 64 photos, 36 POIs, 3 reviews, 6 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166401",
  "property_external_id": "377RTA",
  "property_zillow_url": "https://www.zillow.com/apartments/northglenn-co/regatta-apartments/CjjCL2/",
  "property_apartments_url": "https://www.apartments.com/regatta-apartments-northglenn-co/x7tm96q/",
  "property_google_business_url": "https://www.google.com/maps/place/Regatta+Apartments/data=!4m2!3m1!1s0x0:0x1c9ee15eabc8832e?sa=X&ved=2ahUKEwib0auv4KeSAxUTwckDHYtuOjUQ_BJ6BAgTEAA&hl=en&gl=us",
  "property_linkedin_url": "https://www.linkedin.com/company/regatta-solutions",
  "property_hubspot_id": "5395499313",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "377RTA",
  "property_status": null,
  "property_slug": "regatta",
  "property_name": "Regatta",
  "property_website_url": "https://www.regattaapts.com/",
  "property_domain": "https://www.regattaapts.com/",
  "property_address": "10500 Irma Drive",
  "property_full_address": "10500 Irma Dr, Northglenn, CO 80233",
  "property_address_1": "10500 Irma Dr",
  "property_address_2": null,
  "property_address_city": "Northglenn",
  "property_address_state": "CO",
  "property_address_zip_full": "80233",
  "property_address_zip": "80233",
  "property_address_country": "US",
  "property_address_county": "Adams County",
  "property_neighborhood_address": "Northglenn",
  "property_address_latitude": "39.88838459999999",
  "property_address_longitude": "-104.9600592",
  "property_email": "regatta@liveamc.com",
  "property_phone": "(844) 375-2955",
  "property_call_tracking_phone": "844-375-2955",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Regatta in Northglenn, CO, your lifestyle meets luxury with spacious one, two, and three-bedroom floor plans. Dive into amenities like a sparkling pool, state-of-the-art fitness center, and pet-friendly spaces. Experience vibrant community life with planned activities and serene walking trails. Your dream home awaits—let’s make it yours!",
  "property_long_description": "<p>Welcome home to Regatta Apartments in Northglenn, CO!</p><p><br></p><p>Discover serene and beautiful Northglenn apartment homes that place you in the ideal location perfect for any lifestyle. Enjoy easy access to all the Denver-Aurora-Lakewood area has to offer, including quick routes to the airport, ski slopes, retail shops, restaurants, Coors Field, and the Ball Arena.</p><p><br></p><p>We offer 1, 2, and 3 bedroom apartments in Northglenn that are designed with the resident in mind, including newly renovated interiors, walk-in closets, stainless steel appliances, and gourmet-style kitchens. Within our Northglenn apartment community, you will find gorgeous mountain views, a pet exercise park, a 24-hour state-of-the-art fitness center, a media theater, and more! Here, you will have everything you need in convenience, comfort, and relaxation, making Regatta truly the best of apartments Northglenn has to offer.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
  "property_featured_image_media": {
    "alt_text": "Swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
    "public_id": "019d02c7-322f-71dd-a7ad-9a0f9e41b382",
    "storage_key": "property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
    "width": 1240,
    "height": 828
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "352",
  "property_year_built": "2000",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.30681818181817",
  "property_admin_fee": "200",
  "property_application_fee": "68.67",
  "property_fees_deposit_info": "Security Deposit\n$500 - 1 Month's Rent",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Dogs and cats are welcome (breed restrictions apply for dogs). Maximum of 2 pets per unit.",
  "property_pet_policy_description": "Dogs and cats are welcome (breed restrictions apply for dogs). Maximum of 2 pets per unit. Pet deposit: $300. Monthly pet rent: $35 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://myrentalapplication.com/index/regattaapartments-rta",
  "property_resident_portal_url": "https://auth.domuso.com/signIn?propCode=8593",
  "property_apply_now_url": "https://myrentalapplication.com/index/regattaapartments-rta",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c6-fd04-7406-9bed-2ff596557178.webp",
  "property_primary_logo_media": {
    "alt_text": "Regatta Luxury Apartment Homes logo",
    "public_id": "019d02c6-fd04-7406-9bed-2ff596557178",
    "storage_key": "property/6767906449166401/019d02c6-fd04-7406-9bed-2ff596557178.webp",
    "width": 300,
    "height": 72
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c8-b8bb-710c-b0c9-26f7f5f27759.webp",
  "property_secondary_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c8-b8bb-710c-b0c9-26f7f5f27759",
    "storage_key": "property/6767906449166401/019d02c8-b8bb-710c-b0c9-26f7f5f27759.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c6-fd04-7406-9bed-2ff596557178.webp",
  "property_fav_icon_media": {
    "alt_text": "Regatta Luxury Apartment Homes logo",
    "public_id": "019d02c6-fd04-7406-9bed-2ff596557178",
    "storage_key": "property/6767906449166401/019d02c6-fd04-7406-9bed-2ff596557178.webp",
    "width": 300,
    "height": 72
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c8-d092-72b7-a9f7-a995fb318f5e.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Regatta Luxury Apartment Homes logo",
    "public_id": "019d02c8-d092-72b7-a9f7-a995fb318f5e",
    "storage_key": "property/6767906449166401/019d02c8-d092-72b7-a9f7-a995fb318f5e.webp",
    "width": 300,
    "height": 72
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c8-d81f-778b-9d87-44aedc676bff.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Regatta Luxury Apartment Homes logo",
    "public_id": "019d02c8-d81f-778b-9d87-44aedc676bff",
    "storage_key": "property/6767906449166401/019d02c8-d81f-778b-9d87-44aedc676bff.webp",
    "width": 300,
    "height": 72
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#756f67",
  "property_secondary_color": "#d8d2c8",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#f5f3ef",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "673 - 1220",
  "property_sqft_min": "673",
  "property_sqft_max": "1220",
  "property_price_range": "$1545 - $2465",
  "property_price_min": "1545",
  "property_price_max": "2465",
  "property_available_units": 13,
  "property_facebook_url": "https://www.facebook.com/regattaapts10500/",
  "property_instagram_url": "https://www.instagram.com/regattaapts10500/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJsas-z712bIcRLoPIq17hnhw",
  "property_youtube_url": "https://www.youtube.com/watch?v=qVNIx7JEVH8",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Thornton%2C+CO",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Regatta",
  "property_home_romance_title": "Embrace Your Dream Life in Our Charming Apartment Community",
  "property_home_amenities_blurb": "Welcome to Regatta in Northglenn, CO—a vibrant community where comfort meets lifestyle. Choose from spacious one, two, or three-bedroom apartments, each filled with modern conveniences. Enjoy delightful amenities like a sparkling pool, fitness center, and pet-friendly spaces. Life here is more than just home; it’s a community.",
  "property_home_floorplans_blurb": "At Regatta in Northglenn, CO, your ideal apartment is just a click away. From cozy one-bedroom retreats to spacious three-bedroom havens, each thoughtfully designed floor plan invites you to experience comfort and style. Browse our available homes today and take the first step toward your new lifestyle.",
  "property_home_gallery_blurb": "At Regatta in Northglenn, CO, spacious one, two, and three-bedroom floor plans await you, wrapped in a community brimming with amenities! Take a dip in the pool, unwind in the hot tub, or enjoy a game of tennis. Picture yourself living here, where comfort meets vibrant community life!",
  "property_home_neighborhood_blurb": "Welcome to Regatta, where spacious one, two, and three-bedroom apartments meet a vibrant Northglenn lifestyle. Nestled near Front Range Community College and scenic parks like Carpenter Park, our community also offers easy access to premier fitness centers and exciting attractions. Embrace the perfect blend of convenience and charm!",
  "property_home_reviews_blurb": "At Regatta Apartments in Northglenn, residents thrive in a welcoming community where high ceilings and modern amenities create a cheerful home. With a dedicated staff and responsive maintenance team, our residents love the quiet evenings and the vibrant neighborhood. “My apartment feels more like a home,” one happy tenant shares.",
  "property_neighborhood_blurb": "At Regatta, Northglenn's vibrant community beckons you with diverse recreation and convenience. Unwind at nearby parks like Carpenter Park or challenge your skills at Hyland Hills Golf Course. With destinations like Front Range Community College and fitness centers just moments away, your ideal lifestyle awaits. Check out the local favorites!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Regatta in Northglenn, CO, enjoy a lifestyle brimming with convenience and luxury. Dive into the refreshing pool, challenge friends on the tennis court, or unwind at the spa. With spacious floor plans and pet-friendly features, your ideal home awaits. Join us for a vibrant community experience!",
  "property_applynow_blurb": "At Regatta in Northglenn, CO, your dream home awaits in spacious one, two, or three-bedroom layouts, complete with elegant finishes and modern amenities. Indulge in our inviting pool, state-of-the-art fitness center, and tranquil dog park. Embrace a lifestyle where luxury meets convenience—lease online today and elevate your living experience!",
  "property_contactus_blurb": "At Regatta in Northglenn, CO, your ideal home awaits with spacious one, two, and three-bedroom floor plans designed for comfort and style. Each apartment is a canvas for your unique lifestyle. Have questions? Contact our leasing team today to learn more about how you can make Regatta your new home!",
  "property_faqs_blurb": "At Regatta in Northglenn, CO, our diverse floor plans—including one, two, and three-bedroom options—cater to every lifestyle. Got questions? Our FAQs page is your go-to resource for answers about our vibrant community and unique amenities. Dive in and get informed today!",
  "property_floorplans_blurb": "At Regatta in Northglenn, CO, our thoughtfully designed floor plans cater to every lifestyle. Choose from spacious one, two, or three-bedroom layouts to suit your needs. Embrace comfort and style as you find the perfect home. Browse our available apartment homes today and elevate your living experience!",
  "property_gallery_blurb": "At Regatta in Northglenn, CO, envision your life in spacious one, two, or three-bedroom homes brimming with modern amenities. From relaxing by the pool to enjoying the playground, fitness center, and vibrant social activities, our community makes every day extraordinary. Picture yourself living here amidst luxury and convenience!",
  "property_interactivemap_blurb": "Welcome to Regatta in Northglenn, CO, where luxury meets comfort. Choose from spacious one, two, or three-bedroom apartments, each featuring exquisite amenities like a pool, fitness center, and dog park. Use our interactive community map to find your perfect home among the serene surroundings and vibrant lifestyle. ",
  "property_pets_blurb": "At Regatta in Northglenn, CO, your four-legged friends are family too! Enjoy spacious living with your pets, as we happily welcome dogs and cats (breed restrictions apply). With nearby parks and trails, adventures await right outside your door. Join our vibrant community and embrace a pet-friendly lifestyle!",
  "property_referafriend_blurb": "At Regatta in Northglenn, CO, our vibrant community welcomes one, two, and three-bedroom floor plans designed for comfort and connection. Great friends make great neighbors—share the love and refer a friend today to experience a lifestyle filled with warmth, convenience, and unforgettable moments!",
  "property_residentaccess_blurb": "Welcome to the Regatta community in Northglenn, CO, where comfort meets convenience. Our diverse floor plans—one, two, and three bedrooms—cater to every lifestyle. Access your resident portal today to effortlessly manage rent payments, schedule maintenance, and enjoy all the benefits of your home sweet home!",
  "property_reviews_blurb": "At Regatta Apartments in Northglenn, CO, our residents rave about the welcoming atmosphere and exceptional service. One happy tenant shares, “From office staff to neighbors, everyone has been great.” With high ceilings, a friendly community, and convenient amenities, you’ll discover a tranquil haven that truly feels like home.",
  "property_created_at": "1758216249170",
  "property_scheduletour_blurb": "At Regatta in Northglenn, CO, vibrant living awaits in our thoughtfully designed one, two, and three-bedroom apartments. Each floor plan harmonizes comfort and style, ensuring a perfect fit for your lifestyle. Schedule a tour today and see what our residents rave about in their experience!",
  "property_thankyou_blurb": "Thank you for connecting with Regatta in Northglenn, CO! We offer a range of stylish floor plans—one, two, and three bedrooms—tailored to fit your lifestyle. A dedicated team member will reach out shortly to help you embark on your journey to comfortable, modern living. Stay tuned!",
  "property_virtualtours_blurb": "Experience the charm of Regatta in Northglenn, CO, where modern living meets comfort. Our diverse floor plans, including one, two, and three-bedroom options, perfectly suit your lifestyle. Take a virtual tour today and envision your new home in this vibrant community filled with exceptional amenities and inviting spaces!",
  "property_copyright": "2025 All Rights Reserved. Regatta",
  "property_seo_title_home": "Regatta |  Apartments in Northglenn, CO",
  "property_seo_description_home": "Experience luxury living at Regatta in Northglenn! Choose from stylish floor plans, enjoy top-tier amenities, and relax in your new community. Ready to move?",
  "property_seo_title_floorplans": "Floor Plans | Northglenn, CO Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Regatta in Northglenn, CO! Choose from one, two, or three-bedroom floor plans that fit your lifestyle. Browse now to see more!",
  "property_seo_title_amenities": "Amenities | Northglenn, CO Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury at Regatta in Northglenn, CO! Enjoy a refreshing pool and pet-friendly amenities designed for your active lifestyle.",
  "property_seo_title_gallery": "Gallery | Apartments in Northglenn, CO",
  "property_seo_description_gallery": "Unwind at Regatta in Northglenn, CO. Our vibrant community features stunning floor plans, luxurious amenities, and serene outdoor spaces. Picture your future!",
  "property_seo_title_virtualtours": "Virtual Tours | Regatta Apartments",
  "property_seo_description_virtualtours": "Experience Regatta's vibrant community in Northglenn, CO! Take a virtual tour of stylish one-, two-, and three-bedroom apartments tailored to your lifestyle.",
  "property_seo_title_interactivemap": "Interactive Map | Regatta Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Regatta in Northglenn, CO! Explore spacious floor plans and amenities with our interactive map. Your lifestyle awaits!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Northglenn, CO",
  "property_seo_description_neighborhood": "Experience life at Regatta in Northglenn, CO! Dive into vibrant neighborhoods, local favorites, and nearby attractions just steps from your dream home.",
  "property_seo_title_contact": "Contact Us | Regatta",
  "property_seo_description_contact": "Connect with our Regatta team in Northglenn, CO for personalized assistance. We're ready to help you find your perfect one, two, or three-bedroom apartment!",
  "property_seo_title_faqs": "FAQs | Apartments in Northglenn, CO",
  "property_seo_description_faqs": "Find answers to your burning questions about Regatta in Northglenn, CO. Learn about our amenities, floor plans, and more—your new home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Northglenn, CO",
  "property_seo_description_reviews": "Discover the joys of Regatta in Northglenn, CO! Explore resident reviews and see how our vibrant community and amenities create your perfect home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Northglenn, CO",
  "property_seo_description_applynow": "Discover vibrant living at Regatta, Northglenn, CO! Spacious floor plans, luxurious amenities, and a thriving community await. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Regatta",
  "property_seo_description_residentaccess": "Seamlessly manage your home at Regatta in Northglenn, CO. Log in to pay rent, request maintenance, and enjoy hassle-free living today!",
  "property_seo_title_referafriend": "Refer A Friend | Regatta",
  "property_seo_description_referafriend": "Refer your friends to Regatta in Northglenn, CO! Great friends make for great neighbors. Join our vibrant community and enjoy all we have to offer!",
  "property_seo_title_scheduletour": "Schedule a Tour | Regatta",
  "property_seo_description_scheduletour": "Experience the vibrant lifestyle at Regatta in Northglenn, CO. Schedule a tour today and envision your new home in a welcoming community that’s all yours!",
  "property_seo_title_privacy": "Privacy Policy | Regatta",
  "property_seo_description_privacy": "At Regatta in Northglenn, CO, your privacy matters. Learn how we protect your personal information with our comprehensive policy—transparency at its best!",
  "property_seo_title_accessibility": "Website Accessibility | Regatta",
  "property_seo_description_accessibility": "At Regatta in Northglenn, CO, we prioritize digital inclusion and accessibility for all. Experience a welcoming community where everyone belongs.",
  "property_seo_title_sitemap": "Sitemap | Regatta",
  "property_seo_description_sitemap": "Navigate your way through Regatta in Northglenn, CO! Check out our sitemap for a clear view of our vibrant community and find your perfect home today!",
  "property_seo_title_thankyou": "Thank You | Regatta",
  "property_seo_description_thankyou": "Thank you for connecting with Regatta! Your inquiry is in good hands—get ready to embrace modern living in beautiful Northglenn, CO. We'll be in touch soon!",
  "property_seo_title_pets": "Pet Policy | Apartments in Northglenn, CO",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293636065",
  "amenities": [
    {
      "id": "ec_389157a6831d59ff921d0570",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9391d64958fa078b858d9fb8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Barbecue Area with Fire Pit",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ba4c917659b6fa1a5e5aeb0a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Tanning Bed",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b24fb0f23a43ffec1b5ad726",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Media Center & Theater",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_17042fdf07de799d14931241",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Dog Wash",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ca02ecf779e183d3331c4a1b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Bike Repair",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6f913b93b7f2e5dbb692feae",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Splash Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d3084f8022fbabfe6a6ddbe0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "24‑Hour State‑of‑the‑Art Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cee30c1d0aabcc9f0bf1d4fd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Children's Lounge in Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f1e3ff5643ecbe4cfe23685",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Open‑air hot tub for year‑round use",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_69c794e05fbbfe08b2508fea",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Sports Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_db012077b4c214d47447774b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Magnificent Year‑Round Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_05eb4d131368f9c41d8aaba6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Gated Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ffa97a74820b83c476c932b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Mountain Views",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f299b4f16ba7cc7d0144c23",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Online Rental Payment",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d37f9c6ba5a8e5d07ad1af27",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Beautiful Landscaping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fb60dd1393dc26f1e6bb20c1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Referral Programs",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7b1d4b137be170690c473292",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Package Acceptance At The Office",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_25f04ebfc9c12e55fca83da2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Walk‑in Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be4fc97b915807b65f806a08",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_56b0af8291d72c51e7752183",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Private Patios/Balconies",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_db39c591e993a2b1b30bfb92",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de496523a1a1d19eb9dab69c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Personal Storage Areas",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ff243c5d5b8365d0fcad54bf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "New/Renovated Interior",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_37c295b6d98cb37291486288",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Large Oval Tubs*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24581d52e8b3e482eb2d8263",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Intrusion Alarm Systems",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4f2dac2637ecc5b1f7d9b1df",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Individually controlled central air conditioning and heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b22ef18e2b325dd62f4ccbc5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Gourmet Kitchens",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3729e40128fee6ce1385854e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Gas‑Burning Fireplaces*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_64639116579332099f245c61",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_298d6025503ccdda9a45ad7f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_94b7c1133c888c3e0fe5b023",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7c4cd8eaa4319e3f518cb1c9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling Fans*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab77f22acaae8ddab5c3d5ff",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Built‑in Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e51aeac9ca783091b299a1f2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "9‑Foot Ceilings with Crown Molding*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e5d254c2d1a01b668970d8f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "external_id": "false",
      "title": "Full Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_8e89a1f3-465f-44d1-b3b5-a121f6e0a84b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b3-863e-736d-9ec6-1371ddfc755d.webp",
      "image_media": {
        "alt_text": "Outdoor water play area with splash features, lounge chairs, and a swimming pool.",
        "public_id": "01a034b3-863e-736d-9ec6-1371ddfc755d",
        "storage_key": "property/6767906449166401/01a034b3-863e-736d-9ec6-1371ddfc755d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy refreshing fun at our outdoor water play area, complete with splash features and ample lounge seating, adjacent to our sparkling swimming pool.",
      "link": "",
      "alt_text": "Outdoor water play area with splash features, lounge chairs, and a swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_06ed3d36-4c0c-49a5-8787-20705bead0da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b3-8457-70aa-b657-31649d36afd5.webp",
      "image_media": {
        "alt_text": "Outdoor splash pad area with lounge chairs and apartment buildings in the background.",
        "public_id": "01a034b3-8457-70aa-b657-31649d36afd5",
        "storage_key": "property/6767906449166401/01a034b3-8457-70aa-b657-31649d36afd5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy the refreshing splash pad and outdoor seating area, perfect for sunny days.",
      "link": "",
      "alt_text": "Outdoor splash pad area with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_32962665-cbb4-4767-b757-7ed6d643ef51",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b3-81d1-757e-9791-8c6fda9210a2.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with couches and tables under a wooden pergola near apartment buildings.",
        "public_id": "01a034b3-81d1-757e-9791-8c6fda9210a2",
        "storage_key": "property/6767906449166401/01a034b3-81d1-757e-9791-8c6fda9210a2.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind in our outdoor seating area, complete with comfortable couches and tables, perfect for enjoying the fresh air and scenic views.",
      "link": "",
      "alt_text": "Outdoor seating area with couches and tables under a wooden pergola near apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e583aef6-7da9-4438-892c-662fd81f0a18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b3-7e96-703d-9cf3-484c8ad33373.webp",
      "image_media": {
        "alt_text": "Resort-style outdoor swimming pool with lounge chairs and a fountain.",
        "public_id": "01a034b3-7e96-703d-9cf3-484c8ad33373",
        "storage_key": "property/6767906449166401/01a034b3-7e96-703d-9cf3-484c8ad33373.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning resort-style swimming pool, complete with comfortable lounge seating and a relaxing water fountain. Perfect for unwinding on sunny days.",
      "link": "",
      "alt_text": "Resort-style outdoor swimming pool with lounge chairs and a fountain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_23fff07f-99ae-4c8a-ac65-e4b546103343",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b3-5e87-7512-bb36-8ec32551917b.webp",
      "image_media": {
        "alt_text": "Outdoor patio with tables and chairs, overlooking the pool.",
        "public_id": "01a034b3-5e87-7512-bb36-8ec32551917b",
        "storage_key": "property/6767906449166401/01a034b3-5e87-7512-bb36-8ec32551917b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy al fresco dining and relaxation at our community's outdoor patio, complete with tables, chairs, and a barbecue area, all with a view of the sparkling pool.",
      "link": "",
      "alt_text": "Outdoor patio with tables and chairs, overlooking the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_02376718-27e5-49e3-a277-77fe3b3a26ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b3-60d9-73fd-825c-daabda3b7524.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with fountains and lounge chairs in front of apartment buildings.",
        "public_id": "01a034b3-60d9-73fd-825c-daabda3b7524",
        "storage_key": "property/6767906449166401/01a034b3-60d9-73fd-825c-daabda3b7524.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, complete with soothing fountains and ample lounge seating.",
      "link": "",
      "alt_text": "Outdoor swimming pool with fountains and lounge chairs in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8f1023e4-1c24-4039-b883-483b0e13636e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b3-5f2b-7178-a7e7-2b9921d3ef29.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a fire pit and chairs, with apartment buildings in the background.",
        "public_id": "01a034b3-5f2b-7178-a7e7-2b9921d3ef29",
        "storage_key": "property/6767906449166401/01a034b3-5f2b-7178-a7e7-2b9921d3ef29.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy cozy evenings around the fire pit in our outdoor seating area, perfect for gathering with friends and neighbors.",
      "link": "",
      "alt_text": "Outdoor seating area with a fire pit and chairs, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_89761508-38aa-4d3a-9f26-f9b71d30726e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b3-5ede-7353-bc42-39f4f4f1b640.webp",
      "image_media": {
        "alt_text": "Swimming pool and lounge chairs at a multifamily property with apartment buildings in the background.",
        "public_id": "01a034b3-5ede-7353-bc42-39f4f4f1b640",
        "storage_key": "property/6767906449166401/01a034b3-5ede-7353-bc42-39f4f4f1b640.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping. The perfect place to relax and unwind.",
      "link": "",
      "alt_text": "Swimming pool and lounge chairs at a multifamily property with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_667de890-bf1c-4c61-a878-51111abf8285",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b3-5ed1-72fb-962a-2ff1ee049a42.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with built-in grills and seating under a pergola.",
        "public_id": "01a034b3-5ed1-72fb-962a-2ff1ee049a42",
        "storage_key": "property/6767906449166401/01a034b3-5ed1-72fb-962a-2ff1ee049a42.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings with our spacious grilling area, complete with multiple grills and comfortable seating under a shaded pergola.",
      "link": "",
      "alt_text": "Outdoor grilling area with built-in grills and seating under a pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d726a3ad-9fc8-4ab5-8bfa-cbca7e1265de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b3-59d9-76cd-a2e1-1ce2ba415fac.webp",
      "image_media": {
        "alt_text": "Outdoor hot tub and swimming pool area with lounge chairs and apartment buildings in the background.",
        "public_id": "01a034b3-59d9-76cd-a2e1-1ce2ba415fac",
        "storage_key": "property/6767906449166401/01a034b3-59d9-76cd-a2e1-1ce2ba415fac.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy relaxation and recreation at our community's sparkling outdoor swimming pool and bubbling hot tub, surrounded by comfortable lounge chairs and the beautiful apartment buildings.",
      "link": "",
      "alt_text": "Outdoor hot tub and swimming pool area with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ba18cc2a-302b-4790-b46a-15c735ecc6bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b3-59da-759c-ba4c-37bb299acbf5.webp",
      "image_media": {
        "alt_text": "Jacuzzi spa with bubbling water and lounge chairs by the building.",
        "public_id": "01a034b3-59da-759c-ba4c-37bb299acbf5",
        "storage_key": "property/6767906449166401/01a034b3-59da-759c-ba4c-37bb299acbf5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a relaxing soak in our bubbling jacuzzi spa, complete with comfortable lounge chairs and a beautiful outdoor setting.",
      "link": "",
      "alt_text": "Jacuzzi spa with bubbling water and lounge chairs by the building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_35fae773-1fb2-420e-867c-2975e7280bad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b3-58d2-763d-8002-2e17a1567c16.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "01a034b3-58d2-763d-8002-2e17a1567c16",
        "storage_key": "property/6767906449166401/01a034b3-58d2-763d-8002-2e17a1567c16.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and a serene atmosphere.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1580aec5-19e1-481b-bc71-d998e3d02190",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b3-563f-73ab-815e-c37bb8965fa9.webp",
      "image_media": {
        "alt_text": "Gym with weight racks, dumbbells, a cable machine, and benches.",
        "public_id": "01a034b3-563f-73ab-815e-c37bb8965fa9",
        "storage_key": "property/6767906449166401/01a034b3-563f-73ab-815e-c37bb8965fa9.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center features weight machines, free weights, cardio equipment, and more to help you stay active and healthy.",
      "link": "",
      "alt_text": "Gym with weight racks, dumbbells, a cable machine, and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_592afe27-7414-4e7a-8fca-38107daf492c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b3-585b-76cf-bf3f-0dba509b5e2d.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "01a034b3-585b-76cf-bf3f-0dba509b5e2d",
        "storage_key": "property/6767906449166401/01a034b3-585b-76cf-bf3f-0dba509b5e2d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_99ceeb3a-1045-43fb-b409-e461f0e59de2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b3-3cd9-74b4-9cd5-39716afbef33.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, stair climber, elliptical machines, and weight equipment.",
        "public_id": "01a034b3-3cd9-74b4-9cd5-39716afbef33",
        "storage_key": "property/6767906449166401/01a034b3-3cd9-74b4-9cd5-39716afbef33.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines, free weights, and a dedicated space for functional training. Enjoy a workout with a view of the pool area.",
      "link": "",
      "alt_text": "Gym with treadmills, stair climber, elliptical machines, and weight equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f03001e4-7e36-4a65-87d6-8cfa11ea1091",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b3-3cdf-7399-99df-2ceb13653a31.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with cardio machines, weight training equipment, and a cable crossover machine.",
        "public_id": "01a034b3-3cdf-7399-99df-2ceb13653a31",
        "storage_key": "property/6767906449166401/01a034b3-3cdf-7399-99df-2ceb13653a31.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a wide array of cardio and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Well-equipped fitness center with cardio machines, weight training equipment, and a cable crossover machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7b338c77-2460-4826-a686-548c028d5aa2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b3-3b60-70eb-ba02-e569c5c9a040.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot and green spaces.",
        "public_id": "01a034b3-3b60-70eb-ba02-e569c5c9a040",
        "storage_key": "property/6767906449166401/01a034b3-3b60-70eb-ba02-e569c5c9a040.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "View of apartment buildings from a balcony, showcasing the exterior architecture and surrounding parking and landscaping.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with parking lot and green spaces.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1913c0b9-51ad-439d-b6dd-74bf51303b41",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b3-3593-7468-82fb-67ecfa82b34a.webp",
      "image_media": {
        "alt_text": "Entrance to Regatta apartments with double glass doors and brick facade.",
        "public_id": "01a034b3-3593-7468-82fb-67ecfa82b34a",
        "storage_key": "property/6767906449166401/01a034b3-3593-7468-82fb-67ecfa82b34a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "The welcoming entrance to Regatta apartments, featuring classic brickwork, elegant double glass doors, and decorative shield emblems.",
      "link": "",
      "alt_text": "Entrance to Regatta apartments with double glass doors and brick facade.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ecaac22f-0eed-491c-85bd-e2c52514390a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b3-3a8b-73dd-ae3a-bcc7940383fe.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with treadmills, ellipticals, stair climbers, and free weights.",
        "public_id": "01a034b3-3a8b-73dd-ae3a-bcc7940383fe",
        "storage_key": "property/6767906449166401/01a034b3-3a8b-73dd-ae3a-bcc7940383fe.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide selection of cardio machines and free weights for a complete workout.",
      "link": "",
      "alt_text": "Well-equipped fitness center with treadmills, ellipticals, stair climbers, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7be22462-a0ac-4833-bb83-4dfcbc9318a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b3-3588-755a-a8a3-cb02b6288b1e.webp",
      "image_media": {
        "alt_text": "Exterior of the apartment building with a golf cart and car parked in front.",
        "public_id": "01a034b3-3588-755a-a8a3-cb02b6288b1e",
        "storage_key": "property/6767906449166401/01a034b3-3588-755a-a8a3-cb02b6288b1e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to the clubhouse, where community amenities await you.",
      "link": "",
      "alt_text": "Exterior of the apartment building with a golf cart and car parked in front.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c1c5104c-eebb-43dc-b4c2-6178fab9be5a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b3-3a7e-73e5-bcd9-5665731161d5.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills and stair climbers",
        "public_id": "01a034b3-3a7e-73e5-bcd9-5665731161d5",
        "storage_key": "property/6767906449166401/01a034b3-3a7e-73e5-bcd9-5665731161d5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring treadmills, stair climbers, and weight benches for residents to enjoy.",
      "link": "",
      "alt_text": "Fitness center with treadmills and stair climbers",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a51c006c-8011-4eae-86ca-f2d4595e73be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b3-36ef-75ea-8e16-2bc3c295764c.webp",
      "image_media": {
        "alt_text": "Modern apartment fitness center with cardio machines, weights, and exercise equipment.",
        "public_id": "01a034b3-36ef-75ea-8e16-2bc3c295764c",
        "storage_key": "property/6767906449166401/01a034b3-36ef-75ea-8e16-2bc3c295764c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of cardio machines, free weights, and strength training equipment for a complete workout experience.",
      "link": "",
      "alt_text": "Modern apartment fitness center with cardio machines, weights, and exercise equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c44e7d5c-b7de-432a-a6e2-adcf40397c3a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b3-3cc8-701a-89bc-7f53c19e14ff.webp",
      "image_media": {
        "alt_text": "Fitness center lobby with exercise bikes and a television.",
        "public_id": "01a034b3-3cc8-701a-89bc-7f53c19e14ff",
        "storage_key": "property/6767906449166401/01a034b3-3cc8-701a-89bc-7f53c19e14ff.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to the Regatta Fitness Center lobby. This space features comfortable seating, exercise bikes, and a television for your entertainment.",
      "link": "",
      "alt_text": "Fitness center lobby with exercise bikes and a television.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0d787145-86e6-455f-9f8a-c6fe4def4694",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b3-3568-721b-80d3-87e0ac48c329.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, and weight machines. Features chalkboards and seating areas.",
        "public_id": "01a034b3-3568-721b-80d3-87e0ac48c329",
        "storage_key": "property/6767906449166401/01a034b3-3568-721b-80d3-87e0ac48c329.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring cardio machines, weight training equipment, and a dedicated space for your workouts.",
      "link": "",
      "alt_text": "Gym with treadmills, ellipticals, and weight machines. Features chalkboards and seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eff9df38-f165-4d62-a40f-fa036b2aa943",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-da3e-77ee-bfbe-f6eac9d9686d.webp",
      "image_media": {
        "alt_text": "View from a balcony overlooking apartments and garages, with trees and blue sky.",
        "public_id": "01a034b2-da3e-77ee-bfbe-f6eac9d9686d",
        "storage_key": "property/6767906449166401/01a034b2-da3e-77ee-bfbe-f6eac9d9686d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy your private balcony with a view of the community grounds, including apartments and garages. A perfect spot to relax outdoors.",
      "link": "",
      "alt_text": "View from a balcony overlooking apartments and garages, with trees and blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_60e34f67-a3cc-4432-b677-f2f19aa0439e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-c34f-7549-b636-c69807e054d6.webp",
      "image_media": {
        "alt_text": "Empty bedroom with plush grey carpet, a ceiling fan, and a large window.",
        "public_id": "01a034b2-c34f-7549-b636-c69807e054d6",
        "storage_key": "property/6767906449166401/01a034b2-c34f-7549-b636-c69807e054d6.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring soft grey carpeting, a modern ceiling fan, and ample natural light from a large window overlooking the community.",
      "link": "",
      "alt_text": "Empty bedroom with plush grey carpet, a ceiling fan, and a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4253a4a6-b420-4d2e-a844-e4947b0b085e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-c55a-768d-950d-0da0e4435c07.webp",
      "image_media": {
        "alt_text": "Bedroom with two closets and a ceiling fan.",
        "public_id": "01a034b2-c55a-768d-950d-0da0e4435c07",
        "storage_key": "property/6767906449166401/01a034b2-c55a-768d-950d-0da0e4435c07.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bedroom with plush carpeting, ample closet space, and a ceiling fan for comfort.",
      "link": "",
      "alt_text": "Bedroom with two closets and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c84b2e60-fda5-429a-9608-d6afb14c4c50",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-c552-7619-a786-a4b01ce68e21.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with carpet, ceiling fan, and large window overlooking the exterior.",
        "public_id": "01a034b2-c552-7619-a786-a4b01ce68e21",
        "storage_key": "property/6767906449166401/01a034b2-c552-7619-a786-a4b01ce68e21.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax in this spacious bedroom featuring plush carpeting, a convenient ceiling fan, and ample natural light from the large window.",
      "link": "",
      "alt_text": "Spacious bedroom with carpet, ceiling fan, and large window overlooking the exterior.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9d0a4fc0-c8f0-42c8-a447-f676291252e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-c5aa-749e-8f81-033691ca43ee.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving.",
        "public_id": "01a034b2-c5aa-749e-8f81-033691ca43ee",
        "storage_key": "property/6767906449166401/01a034b2-c5aa-749e-8f81-033691ca43ee.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample wire shelving for all your storage needs. This feature provides convenient organization for your belongings.",
      "link": "",
      "alt_text": "Empty walk-in closet with wire shelving.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_32a49027-8521-477e-a39f-92b75fde2574",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-c562-70fe-a557-02e299de10ba.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving.",
        "public_id": "01a034b2-c562-70fe-a557-02e299de10ba",
        "storage_key": "property/6767906449166401/01a034b2-c562-70fe-a557-02e299de10ba.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample wire shelving for all your storage needs.",
      "link": "",
      "alt_text": "Empty walk-in closet with wire shelving.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c60edbbc-71e0-4ea4-b8af-c68db872b2aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-c300-767c-8353-95985dc72b88.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and bathtub.",
        "public_id": "01a034b2-c300-767c-8353-95985dc72b88",
        "storage_key": "property/6767906449166401/01a034b2-c300-767c-8353-95985dc72b88.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and clean bathroom featuring a single vanity, toilet, and a bathtub with tiled shower surround.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7cb5cab1-83af-4bf7-9e4d-a94850b70755",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-c105-7302-b4ce-d07dd7a517f6.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a laundry room, with an open door leading to a bedroom.",
        "public_id": "01a034b2-c105-7302-b4ce-d07dd7a517f6",
        "storage_key": "property/6767906449166401/01a034b2-c105-7302-b4ce-d07dd7a517f6.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for your convenience, with a view into a carpeted bedroom.",
      "link": "",
      "alt_text": "Washer and dryer in a laundry room, with an open door leading to a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_80c29914-4eab-4a8a-8da3-3f74ef072328",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-c0a1-750a-8d61-71afbb1ed854.webp",
      "image_media": {
        "alt_text": "Modern kitchen with a large sink and stainless steel faucet, opening to a living area with a fireplace.",
        "public_id": "01a034b2-c0a1-750a-8d61-71afbb1ed854",
        "storage_key": "property/6767906449166401/01a034b2-c0a1-750a-8d61-71afbb1ed854.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Open-concept living and kitchen area featuring a fireplace and ample natural light from large windows.",
      "link": "",
      "alt_text": "Modern kitchen with a large sink and stainless steel faucet, opening to a living area with a fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5aee5a52-eb0d-4343-9d8c-c3827a372fb7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-b8d1-7352-9c60-d272c22b4f84.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "01a034b2-b8d1-7352-9c60-d272c22b4f84",
        "storage_key": "property/6767906449166401/01a034b2-b8d1-7352-9c60-d272c22b4f84.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring sleek stainless steel appliances, granite countertops, and ample cabinet space for all your culinary needs.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_916b64b0-867c-4f58-b49a-af3afde1894d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-bff0-7608-bb61-d6cdf3dfbf2a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and dark countertops.",
        "public_id": "01a034b2-bff0-7608-bb61-d6cdf3dfbf2a",
        "storage_key": "property/6767906449166401/01a034b2-bff0-7608-bb61-d6cdf3dfbf2a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring ample cabinet space, a dishwasher, and a full suite of stainless steel appliances for effortless meal preparation.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and dark countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8ace5750-2b62-4b9c-9de4-95f6b8002138",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-a737-7349-acbd-b1739db43763.webp",
      "image_media": {
        "alt_text": "Spacious living room with fireplace and large window",
        "public_id": "01a034b2-a737-7349-acbd-b1739db43763",
        "storage_key": "property/6767906449166401/01a034b2-a737-7349-acbd-b1739db43763.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright and airy living room featuring a cozy fireplace, elegant crown molding, and a large window with a view of the community grounds. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Spacious living room with fireplace and large window",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4533b745-0d7c-4d92-a57f-bdfcc1f5dd54",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-ac4e-76d8-9d07-94b39095f5ee.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with stainless steel appliances and white cabinetry.",
        "public_id": "01a034b2-ac4e-76d8-9d07-94b39095f5ee",
        "storage_key": "property/6767906449166401/01a034b2-ac4e-76d8-9d07-94b39095f5ee.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern kitchen and dining area featuring stainless steel appliances, ample white cabinetry, and a breakfast bar, perfect for entertaining.",
      "link": "",
      "alt_text": "Kitchen and dining area with stainless steel appliances and white cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d8dd90c8-1717-424a-af78-197693ff07b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-a85c-7127-afc6-c03cb143c7b7.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with a white car parked in the foreground.",
        "public_id": "01a034b2-a85c-7127-afc6-c03cb143c7b7",
        "storage_key": "property/6767906449166401/01a034b2-a85c-7127-afc6-c03cb143c7b7.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Exterior view of an apartment building showing its architecture and a parking lot with cars.",
      "link": "",
      "alt_text": "Apartment building exterior with a white car parked in the foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_40c53486-9bad-4293-880a-c453a0dd1e08",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-ac45-733f-866f-855390cfe51e.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and double doors leading to hallway.",
        "public_id": "01a034b2-ac45-733f-866f-855390cfe51e",
        "storage_key": "property/6767906449166401/01a034b2-ac45-733f-866f-855390cfe51e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a decorative fireplace and ample closet space, with access to a hallway.",
      "link": "",
      "alt_text": "Living room with fireplace and double doors leading to hallway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4ae2b75a-244c-43a1-b260-be5aa9f231c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-a86d-761f-8b0f-aa58bea2a8bb.webp",
      "image_media": {
        "alt_text": "Spacious living room with a fireplace and a view of the kitchen area.",
        "public_id": "01a034b2-a86d-761f-8b0f-aa58bea2a8bb",
        "storage_key": "property/6767906449166401/01a034b2-a86d-761f-8b0f-aa58bea2a8bb.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy cozy evenings by the fireplace in this spacious living area, featuring an open-concept design connecting to the kitchen.",
      "link": "",
      "alt_text": "Spacious living room with a fireplace and a view of the kitchen area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6fc9199f-f22e-4c75-aacd-ff618ebc7c02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-a5b0-7419-bfe5-03aea9a20b0b.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot and cars.",
        "public_id": "01a034b2-a5b0-7419-bfe5-03aea9a20b0b",
        "storage_key": "property/6767906449166401/01a034b2-a5b0-7419-bfe5-03aea9a20b0b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings, showcasing the property's architecture and surrounding parking area with vehicles.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with parking lot and cars.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eaec2751-a239-40c5-a639-7e210df6da71",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-a501-741e-9e5b-ab9043128f56.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot and cars.",
        "public_id": "01a034b2-a501-741e-9e5b-ab9043128f56",
        "storage_key": "property/6767906449166401/01a034b2-a501-741e-9e5b-ab9043128f56.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Exterior view of the apartment buildings, showcasing the architecture and parking amenities. The facade features a mix of siding and brick accents.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with parking lot and cars.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ac94cad0-695c-4e63-9c3b-132030f0972c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-a864-707b-a7ff-37e4ac448034.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with fireplace",
        "public_id": "01a034b2-a864-707b-a7ff-37e4ac448034",
        "storage_key": "property/6767906449166401/01a034b2-a864-707b-a7ff-37e4ac448034.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious living room with a modern kitchen and a cozy fireplace. This open-concept layout provides ample space for relaxation and entertainment.",
      "link": "",
      "alt_text": "Living room and kitchen area with fireplace",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_257d14eb-65c3-4c07-a8ee-cb6272fe91ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-a6d1-75ab-9901-08df3a41e871.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and large window",
        "public_id": "01a034b2-a6d1-75ab-9901-08df3a41e871",
        "storage_key": "property/6767906449166401/01a034b2-a6d1-75ab-9901-08df3a41e871.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a cozy fireplace and a large window with a view of the community grounds.",
      "link": "",
      "alt_text": "Living room with fireplace and large window",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ff0ed0c4-c2ae-4443-a21b-a420965da43c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-9345-7546-bebd-e44beab22508.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "01a034b2-9345-7546-bebd-e44beab22508",
        "storage_key": "property/6767906449166401/01a034b2-9345-7546-bebd-e44beab22508.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor pool, complete with comfortable lounge seating and shaded cabanas. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool and lounge area with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_30d4ff1c-e977-4b05-b78e-6a2b480d6dcf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-8ddd-749e-85ab-2f2a71ba75f6.webp",
      "image_media": {
        "alt_text": "Balcony with table and chairs overlooking the pool and community buildings.",
        "public_id": "01a034b2-8ddd-749e-85ab-2f2a71ba75f6",
        "storage_key": "property/6767906449166401/01a034b2-8ddd-749e-85ab-2f2a71ba75f6.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening drink on your private balcony, complete with seating and a view of the community pool.",
      "link": "",
      "alt_text": "Balcony with table and chairs overlooking the pool and community buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6182fe24-86af-461f-9fae-b7a0fbdd0d41",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-8dd2-719d-9998-666021308e2b.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with white cabinets, dark countertop, and silver faucet. Towels hang on the left.",
        "public_id": "01a034b2-8dd2-719d-9998-666021308e2b",
        "storage_key": "property/6767906449166401/01a034b2-8dd2-719d-9998-666021308e2b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Beautifully appointed bathroom featuring a spacious vanity, modern fixtures, and a soaking tub with shower. Perfect for your daily routine.",
      "link": "",
      "alt_text": "Modern bathroom vanity with white cabinets, dark countertop, and silver faucet. Towels hang on the left.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eb245efd-b5bd-4610-bd58-7897d62388f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-8d91-74ab-a72e-1eb09a5fdddc.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, ceiling fan, and large window.",
        "public_id": "01a034b2-8d91-74ab-a72e-1eb09a5fdddc",
        "storage_key": "property/6767906449166401/01a034b2-8d91-74ab-a72e-1eb09a5fdddc.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed, modern ceiling fan, and a large window with a view of the exterior. Includes a closet and entrance to laundry area.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, ceiling fan, and large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fda49c73-b887-4508-8f12-70c54c77d6f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-898f-71fa-8fdc-7c0c3705b476.webp",
      "image_media": {
        "alt_text": "A bedroom featuring a queen-size bed with geometric-patterned bedding, nightstands, a dresser, and a large mirror.",
        "public_id": "01a034b2-898f-71fa-8fdc-7c0c3705b476",
        "storage_key": "property/6767906449166401/01a034b2-898f-71fa-8fdc-7c0c3705b476.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax in this inviting bedroom, complete with a comfortable queen-size bed, stylish nightstands, and ample storage.",
      "link": "",
      "alt_text": "A bedroom featuring a queen-size bed with geometric-patterned bedding, nightstands, a dresser, and a large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c142a458-32ef-4d6b-bc5c-a299d28e4f78",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-891e-7480-bbe0-17741514e4c3.webp",
      "image_media": {
        "alt_text": "Bedroom with a desk and closet",
        "public_id": "01a034b2-891e-7480-bbe0-17741514e4c3",
        "storage_key": "property/6767906449166401/01a034b2-891e-7480-bbe0-17741514e4c3.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable bed, a functional desk area, and a spacious walk-in closet. An adjoining living room is visible through an open doorway.",
      "link": "",
      "alt_text": "Bedroom with a desk and closet",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9cb4e51a-a41a-4d87-bc2f-cea90d14ad00",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-899f-754c-913f-4c3e02968244.webp",
      "image_media": {
        "alt_text": "Spacious walk-in closet with white wire shelving and hanging rods.",
        "public_id": "01a034b2-899f-754c-913f-4c3e02968244",
        "storage_key": "property/6767906449166401/01a034b2-899f-754c-913f-4c3e02968244.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Maximize your storage space in this generous walk-in closet, featuring convenient wire shelving and hanging rods for organized living.",
      "link": "",
      "alt_text": "Spacious walk-in closet with white wire shelving and hanging rods.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_842cf95a-a58e-4d02-a543-c7b33ca5cf3a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-8997-719b-b0e8-27ffe24db63c.webp",
      "image_media": {
        "alt_text": "Bedroom with a closet and a dresser.",
        "public_id": "01a034b2-8997-719b-b0e8-27ffe24db63c",
        "storage_key": "property/6767906449166401/01a034b2-8997-719b-b0e8-27ffe24db63c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A spacious bedroom featuring a modern dresser, a walk-in closet with ample storage, and a comfortable bed with a geometric-patterned comforter.",
      "link": "",
      "alt_text": "Bedroom with a closet and a dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_99cf01ce-b807-41b4-b2e2-2df32c19cb97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-8785-7038-a664-30132f53b644.webp",
      "image_media": {
        "alt_text": "View of a laundry room with a washer and dryer, seen from a bedroom.",
        "public_id": "01a034b2-8785-7038-a664-30132f53b644",
        "storage_key": "property/6767906449166401/01a034b2-8785-7038-a664-30132f53b644.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry with a washer and dryer, just steps from your bedroom.",
      "link": "",
      "alt_text": "View of a laundry room with a washer and dryer, seen from a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5d3928f9-d2fe-456f-8c0e-dc28e78ac435",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-876b-74ea-b1ba-ab48b57854ff.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, decorative pillows, a dresser, and a window overlooking the neighborhood.",
        "public_id": "01a034b2-876b-74ea-b1ba-ab48b57854ff",
        "storage_key": "property/6767906449166401/01a034b2-876b-74ea-b1ba-ab48b57854ff.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax in this serene bedroom, featuring a comfortable queen-size bed, elegant decor, and ample natural light from the large window.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, decorative pillows, a dresser, and a window overlooking the neighborhood.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7913253e-88b4-48e5-a896-1106162f4fd9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-6d61-753d-b41f-0ad808b3fc74.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with brick and siding.",
        "public_id": "01a034b2-6d61-753d-b41f-0ad808b3fc74",
        "storage_key": "property/6767906449166401/01a034b2-6d61-753d-b41f-0ad808b3fc74.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "View of the apartment building exteriors, showcasing the architecture and landscaping.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with brick and siding.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a978c914-1716-44ea-879c-bb3dbf7a1cf2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-6993-76a8-9dca-c1d2a531bdec.webp",
      "image_media": {
        "alt_text": "Dining area adjacent to kitchen in apartment",
        "public_id": "01a034b2-6993-76a8-9dca-c1d2a531bdec",
        "storage_key": "property/6767906449166401/01a034b2-6993-76a8-9dca-c1d2a531bdec.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A stylish dining area with a glass-top table and white chairs, adjacent to a modern kitchen with stainless steel appliances.",
      "link": "",
      "alt_text": "Dining area adjacent to kitchen in apartment",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8ceb8d07-b9c6-49d7-8705-fdfcd6b1661e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-6d7c-7239-a992-ec4f87a2ee0d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and dark countertops.",
        "public_id": "01a034b2-6d7c-7239-a992-ec4f87a2ee0d",
        "storage_key": "property/6767906449166401/01a034b2-6d7c-7239-a992-ec4f87a2ee0d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A spacious and modern kitchen featuring white shaker cabinets, stainless steel appliances, and sleek dark countertops, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and dark countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_45cd9ded-24af-4418-8b83-a5f588f057ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-69e9-7008-a448-ae74f62e1bd1.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, accent chair, and television. A doorway leads to the bedroom.",
        "public_id": "01a034b2-69e9-7008-a448-ae74f62e1bd1",
        "storage_key": "property/6767906449166401/01a034b2-69e9-7008-a448-ae74f62e1bd1.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room featuring a plush sofa, elegant coffee table, and a striking accent chair, perfect for relaxation and entertainment. The adjacent bedroom offers a serene retreat.",
      "link": "",
      "alt_text": "Living room with a sofa, coffee table, accent chair, and television. A doorway leads to the bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_de754ecc-cf41-40cd-8026-f7c7b4351c74",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-6d6b-75e7-a0b3-fffc8701e296.webp",
      "image_media": {
        "alt_text": "Modern living room with gray sofa, blue armchair, coffee table, and dining area with white chairs.",
        "public_id": "01a034b2-6d6b-75e7-a0b3-fffc8701e296",
        "storage_key": "property/6767906449166401/01a034b2-6d6b-75e7-a0b3-fffc8701e296.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Stylish and spacious living and dining area with modern furniture, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern living room with gray sofa, blue armchair, coffee table, and dining area with white chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_30499dfb-aff0-4bfd-a695-8273898b2029",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-6d74-75d2-a6b3-5e3889df7d66.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a grey countertop.",
        "public_id": "01a034b2-6d74-75d2-a6b3-5e3889df7d66",
        "storage_key": "property/6767906449166401/01a034b2-6d74-75d2-a6b3-5e3889df7d66.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample white cabinetry, a sleek grey countertop, and a decorative blue and white rug.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a grey countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_22ff8920-c0c6-4a7e-8fd7-f73f8fb63244",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-693c-70c9-9db6-64d2edb98aa8.webp",
      "image_media": {
        "alt_text": "Living room and dining area of an apartment with a TV and dining table.",
        "public_id": "01a034b2-693c-70c9-9db6-64d2edb98aa8",
        "storage_key": "property/6767906449166401/01a034b2-693c-70c9-9db6-64d2edb98aa8.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious living room and dining area featuring a modern TV stand, a stylish dining set, and elegant decor, perfect for entertaining guests.",
      "link": "",
      "alt_text": "Living room and dining area of an apartment with a TV and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_00fb58fd-d5e2-4cc4-825c-333411f362c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-6d18-709c-969d-197794655296.webp",
      "image_media": {
        "alt_text": "Living room with gray sofa, armchair, coffee table, and balcony access.",
        "public_id": "01a034b2-6d18-709c-969d-197794655296",
        "storage_key": "property/6767906449166401/01a034b2-6d18-709c-969d-197794655296.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable gray sofa, armchair, plush rug, and a coffee table. Sliding glass doors open to a private balcony.",
      "link": "",
      "alt_text": "Living room with gray sofa, armchair, coffee table, and balcony access.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_593957cb-2fdf-4e78-9ddc-21e41777312b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-6901-7130-8a39-48b7a691b40f.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with island and sink.",
        "public_id": "01a034b2-6901-7130-8a39-48b7a691b40f",
        "storage_key": "property/6767906449166401/01a034b2-6901-7130-8a39-48b7a691b40f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Stylish dining area adjacent to a modern kitchen featuring a large island with sink and dishwasher, perfect for entertaining.",
      "link": "",
      "alt_text": "Dining area and kitchen with island and sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_15af1c74-fc90-4989-96d3-2f370c124512",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-68fe-74bc-9266-a60347bc55f9.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with white cabinets, stainless steel appliances, and a glass-top dining table.",
        "public_id": "01a034b2-68fe-74bc-9266-a60347bc55f9",
        "storage_key": "property/6767906449166401/01a034b2-68fe-74bc-9266-a60347bc55f9.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy cooking and dining in this beautifully appointed kitchen and dining area, featuring sleek white cabinetry, stainless steel appliances, and a stylish glass-top dining table perfect for meals with family and friends.",
      "link": "",
      "alt_text": "Modern kitchen and dining area with white cabinets, stainless steel appliances, and a glass-top dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_67752989-cbc8-461f-91d2-6812b9a0886e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "111 E 136th Ave, Thornton, CO 80023, USA",
      "poi_short_description": "Chain restaurant known for hamburgers, fries and milkshakes.",
      "poi_long_description": "People say this hamburger restaurant serves tasty burgers, animal fries, and shakes. They also highlight the reasonable prices, fast service, and friendly staff.\n\nOther reviews mention the food can be messy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-81ee-73a9-9758-ab2f496766e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-81ee-73a9-9758-ab2f496766e6",
        "storage_key": "property/6767906449166401/019d02c7-81ee-73a9-9758-ab2f496766e6.webp",
        "width": 1242,
        "height": 752
      },
      "poi_business_url": "https://locations.in-n-out.com/376",
      "poi_directions_map_url": "https://maps.google.com/?cid=4281691239353818495&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "39.9434321",
      "poi_longitude": "-104.9841979",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b451-70fb-b23f-ca499b6ecdda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b451-70fb-b23f-ca499b6ecdda",
        "storage_key": "property/6767906449166401/019d02c7-b451-70fb-b23f-ca499b6ecdda.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJE02a9EZ1bIcRfx2WL3-fazs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_1f5f9548-f480-4999-8a83-4d8d2e5adcaf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Cinzzetti's",
      "poi_type": "Restaurants",
      "poi_address": "281 W 104th Ave, Northglenn, CO 80234, USA",
      "poi_short_description": "Italian, all-you-can-eat eatery serving a wide variety of dishes including pizzas, pasta and desserts at exhibition cooking stations.",
      "poi_long_description": "People say this Italian restaurant offers a wide variety of delicious dishes, including pasta, pizza, seafood, and a fantastic dessert bar with gelato and made-to-order crepes. They also highlight the fun and lively atmosphere, the great value for the all-you-can-eat buffet, and the friendly and attentive service.\n\nOther reviews mention the restaurant can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-81e4-773b-9dc0-184d1a8e9f3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-81e4-773b-9dc0-184d1a8e9f3c",
        "storage_key": "property/6767906449166401/019d02c7-81e4-773b-9dc0-184d1a8e9f3c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cinzzettis.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1310787403457533659&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cinzzettis",
      "poi_latitude": "39.8908655",
      "poi_longitude": "-104.9886265",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 303-451-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b451-70fb-b23f-ca499b6ecdda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b451-70fb-b23f-ca499b6ecdda",
        "storage_key": "property/6767906449166401/019d02c7-b451-70fb-b23f-ca499b6ecdda.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSZDxlWN2bIcR25Yk1zLaMBI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_04b770f7-1dab-43db-96b2-e4d1d429d660",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Lazy Dog Restaurant & Bar",
      "poi_type": "Restaurants",
      "poi_address": "14618 Delaware St, Westminster, CO 80023, USA",
      "poi_short_description": "Casual American eatery with an outdoor dining patio offering burgers and hot dogs, plus a bar with house beers.",
      "poi_long_description": "Diners say this American restaurant serves up delicious bison burgers, bison meatloaf, and chicken pot pie, and they praise the extensive beer menu. They also highlight the dog-friendly patio, lively atmosphere with a large fireplace, and attentive service.\n\nSome reviews mention the food can be pricey.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-821e-744c-8830-f169a4a93ec3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-821e-744c-8830-f169a4a93ec3",
        "storage_key": "property/6767906449166401/019d02c7-821e-744c-8830-f169a4a93ec3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://lazydogrestaurants.com/locations/orchard-town-center-westminster-co",
      "poi_directions_map_url": "https://maps.google.com/?cid=2628571396269046921&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lazy-dog-restaurant--bar",
      "poi_latitude": "39.96133529999999",
      "poi_longitude": "-104.9891532",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 720-459-5613",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b451-70fb-b23f-ca499b6ecdda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b451-70fb-b23f-ca499b6ecdda",
        "storage_key": "property/6767906449166401/019d02c7-b451-70fb-b23f-ca499b6ecdda.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJizhcHSJ1bIcRiXxeFcKPeiQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_13d71caa-32e0-4fe5-ac02-49107c11aaca",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "350 W 120th Ave, Northglenn, CO 80234, USA",
      "poi_short_description": "American comfort food, including breakfast, in a casual setting with a fireplace and gift shop.",
      "poi_long_description": "People say this restaurant serves comfort food, including chicken and dumplings, chicken fried steak, and pot roast. They also highlight the reasonable prices, cozy atmosphere with a fireplace, and the gift shop.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-80f2-7119-96ad-46842110f6f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-80f2-7119-96ad-46842110f6f0",
        "storage_key": "property/6767906449166401/019d02c7-80f2-7119-96ad-46842110f6f0.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/co/northglenn/226/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=9250721756427515292&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "39.9130892",
      "poi_longitude": "-104.991557",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 303-280-9634",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b451-70fb-b23f-ca499b6ecdda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b451-70fb-b23f-ca499b6ecdda",
        "storage_key": "property/6767906449166401/019d02c7-b451-70fb-b23f-ca499b6ecdda.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ2YNps51bIcRnPXWz2wqYYA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_ec81a5c6-0670-452a-8a17-a2d58191ed75",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Dave & Buster's Westminster",
      "poi_type": "Restaurants",
      "poi_address": "10667 Westminster Blvd, Westminster, CO 80020, USA",
      "poi_short_description": "Chain eatery and arcade offering happy-hour specials, cocktails, and sports on TV.",
      "poi_long_description": "People say this restaurant offers standard food and good drinks. They also highlight the friendly staff and fun arcade games.\n\nSome reviews mention the games can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-85f4-76ba-a03e-c371cf92591c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-85f4-76ba-a03e-c371cf92591c",
        "storage_key": "property/6767906449166401/019d02c7-85f4-76ba-a03e-c371cf92591c.webp",
        "width": 1280,
        "height": 864
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/westminster",
      "poi_directions_map_url": "https://maps.google.com/?cid=2520936433080706881&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dave--busters-westminster",
      "poi_latitude": "39.8902934",
      "poi_longitude": "-105.0705643",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 303-438-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b451-70fb-b23f-ca499b6ecdda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b451-70fb-b23f-ca499b6ecdda",
        "storage_key": "property/6767906449166401/019d02c7-b451-70fb-b23f-ca499b6ecdda.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxzmM_yiKa4cRQacdU1Qq_CI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5cf5c274-e62e-4251-a5bd-8c32a0cfbf15",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Denver Premium Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "13801 Grant St, Thornton, CO 80023, USA",
      "poi_short_description": "Kid-friendly outdoor outlet mallfeaturing a variety of big-brand stores and a relaxed vibe.",
      "poi_long_description": "People say this outlet mall offers a wide selection of stores with great deals on shoes, clothing, and sportswear. They highlight the clean, open-air layout, the fun playground for kids, and the ample parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-8708-7580-9958-49b58dbb34a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-8708-7580-9958-49b58dbb34a4",
        "storage_key": "property/6767906449166401/019d02c7-8708-7580-9958-49b58dbb34a4.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/denver",
      "poi_directions_map_url": "https://maps.google.com/?cid=5339953701903053161&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "denver-premium-outlets",
      "poi_latitude": "39.9477781",
      "poi_longitude": "-104.985765",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-200-3805",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b449-7433-bacc-8fd92b387da1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b449-7433-bacc-8fd92b387da1",
        "storage_key": "property/6767906449166401/019d02c7-b449-7433-bacc-8fd92b387da1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJb3OUMfx1bIcRabH2fplTG0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_dbb9a601-2372-4132-8841-f40f8c900e34",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "H Mart Westminster",
      "poi_type": "Shopping & Retail",
      "poi_address": "Northview Shopping Center, 5036 W 92nd Ave, Westminster, CO 80031, USA",
      "poi_short_description": "Asian supermarket featuring baked goods, takeout meals, and fresh produce.",
      "poi_long_description": "People say this Asian grocery store offers a wide selection of fresh produce, meat, seafood, and Asian sauces, as well as a bakery, boba shop, and liquor store. They highlight the affordable prices and the friendly, helpful staff. They also like the clean and well-stocked shelves.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-86a4-7277-bb8d-32efb41cd972.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-86a4-7277-bb8d-32efb41cd972",
        "storage_key": "property/6767906449166401/019d02c7-86a4-7277-bb8d-32efb41cd972.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.myhmart.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10422094880193994027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-mart-westminster",
      "poi_latitude": "39.86243959999999",
      "poi_longitude": "-105.0515651",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 720-287-5341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b454-7228-ae3a-bae005a68ac2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b454-7228-ae3a-bae005a68ac2",
        "storage_key": "property/6767906449166401/019d02c7-b454-7228-ae3a-bae005a68ac2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRXk-E8aJa4cRK11hLRO4opA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_1426d37d-3a50-41df-99f4-0b8e9085987d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "4451 Main St, Westminster, CO 80031, USA",
      "poi_short_description": "Grocery chain with a variety of high-quality products, including organic options, and prepared foods.",
      "poi_long_description": "People say this grocery store offers a wide selection of high-quality products, especially the Chantilly cakes, fresh produce, and hot bar. They also highlight the friendly and helpful staff, and the clean and well-organized store.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-8700-77bb-812a-cfb4bd073fad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-8700-77bb-812a-cfb4bd073fad",
        "storage_key": "property/6767906449166401/019d02c7-8700-77bb-812a-cfb4bd073fad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/bradburn?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=6153799331023187634&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "39.913434",
      "poi_longitude": "-105.0446913",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 303-439-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b454-7228-ae3a-bae005a68ac2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b454-7228-ae3a-bae005a68ac2",
        "storage_key": "property/6767906449166401/019d02c7-b454-7228-ae3a-bae005a68ac2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk2xRoXKKa4cRsm6sKOOvZlU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_18b4a303-56d7-417c-a8b5-5745d6538df4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "10003 Grant St, Denver, CO 80229, USA",
      "poi_short_description": "Well-stocked, big-box retailer offering a selection of tools, home-improvement supplies, and construction products.",
      "poi_long_description": "People say this home improvement store is clean, well-organized, and has friendly and helpful staff who are always willing to assist customers in finding the right products. They also highlight the efficient delivery service and the wide selection of items available in-store.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-8ab8-7404-8223-808506a7d87f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-8ab8-7404-8223-808506a7d87f",
        "storage_key": "property/6767906449166401/019d02c7-8ab8-7404-8223-808506a7d87f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Thornton/CO/Thornton/80229/1503?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=2111239020270018171&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "39.8799629",
      "poi_longitude": "-104.9859384",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 303-255-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b449-7433-bacc-8fd92b387da1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b449-7433-bacc-8fd92b387da1",
        "storage_key": "property/6767906449166401/019d02c7-b449-7433-bacc-8fd92b387da1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJt1woHGB2bIcRe14j_7OgTB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_126cfadb-2324-4711-abbd-57e33b44ca32",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "American Furniture Warehouse",
      "poi_type": "Shopping & Retail",
      "poi_address": "8501 Grant St, Thornton, CO 80229, USA",
      "poi_short_description": "Chain home-goods retailer featuring an array of stylish furniture options, including sofas, mattresses, dining sets and more.",
      "poi_long_description": "People say this furniture store offers a wide selection of bedroom sets, chairs, couches, tables, and mattresses. They highlight the reasonable prices, good deals, and the quality of the furniture. They also like the friendly, professional, and efficient delivery service. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-8ba8-7423-9430-53d62b7a7e5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-8ba8-7423-9430-53d62b7a7e5f",
        "storage_key": "property/6767906449166401/019d02c7-8ba8-7423-9430-53d62b7a7e5f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.afw.com/stores/co/thornton",
      "poi_directions_map_url": "https://maps.google.com/?cid=9573886734892612901&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "american-furniture-warehouse",
      "poi_latitude": "39.8513053",
      "poi_longitude": "-104.9830442",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-289-3311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b449-7433-bacc-8fd92b387da1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b449-7433-bacc-8fd92b387da1",
        "storage_key": "property/6767906449166401/019d02c7-b449-7433-bacc-8fd92b387da1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOU8hpwd3bIcRJT0ZwUJH3YQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_95e5d13a-ceec-41e6-83d9-b78460350c90",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Front Range Community College - Westminster",
      "poi_type": "Education",
      "poi_address": "Wolf Central (Welcome Center, 3645 W 112th Ave Entrance 1, Westminster, CO 80031, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-8bd1-71f7-98da-c64c6b186d56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-8bd1-71f7-98da-c64c6b186d56",
        "storage_key": "property/6767906449166401/019d02c7-8bd1-71f7-98da-c64c6b186d56.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.frontrange.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11260354031968358793&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "front-range-community-college---westminster",
      "poi_latitude": "39.9015881",
      "poi_longitude": "-105.0374089",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 303-404-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b43b-7159-b915-ce0f5e9755de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b43b-7159-b915-ce0f5e9755de",
        "storage_key": "property/6767906449166401/019d02c7-b43b-7159-b915-ce0f5e9755de.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpVi23wWKa4cRiZGcCFXQRJw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_86ee3275-791f-4165-b28c-499f4c868b80",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Anythink Wright Farms",
      "poi_type": "Education",
      "poi_address": "5877 E 120th Ave, Thornton, CO 80602, USA",
      "poi_short_description": "Charming library featuring a cafe, an art studio and study rooms, plus DVDs and 3D printers.",
      "poi_long_description": "People say this public library offers a massive selection of books, movies, and computers, as well as a 3D printing lab and a variety of study spaces. They highlight the welcoming and friendly atmosphere, and the impressive children's section with toys and puppets. They also like the helpful and pleasant staff, and the clean facilities. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-8be6-703f-8fbb-bfb35d92ec58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-8be6-703f-8fbb-bfb35d92ec58",
        "storage_key": "property/6767906449166401/019d02c7-8be6-703f-8fbb-bfb35d92ec58.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.anythinklibraries.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7906305509954867936&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "anythink-wright-farms",
      "poi_latitude": "39.9145255",
      "poi_longitude": "-104.9207255",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-405-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b43b-7159-b915-ce0f5e9755de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b43b-7159-b915-ce0f5e9755de",
        "storage_key": "property/6767906449166401/019d02c7-b43b-7159-b915-ce0f5e9755de.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4_ROJudzbIcR4NKSzvjWuG0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_b042618f-de25-4eb2-9cc7-ae7714733f2b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Water World",
      "poi_type": "Entertainment",
      "poi_address": "8801 N Pecos St, Federal Heights, CO 80260, USA",
      "poi_short_description": "Family-focused park featuring 70 acres of water rides, wave pools, and a lazy river, plus free parking.",
      "poi_long_description": "People say this water park offers a wide variety of fun water slides, a wave pool, and a lazy river. They also highlight the friendly staff, clean grounds, and the option to bring your own food.\n\nOther reviews mention the lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-8f86-71dc-8904-ae9d845c6128.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-8f86-71dc-8904-ae9d845c6128",
        "storage_key": "property/6767906449166401/019d02c7-8f86-71dc-8904-ae9d845c6128.webp",
        "width": 1280,
        "height": 756
      },
      "poi_business_url": "http://www.waterworldcolorado.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14131190951601773321&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "water-world",
      "poi_latitude": "39.85836",
      "poi_longitude": "-105.0095554",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-427-7873",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b96a-7647-b54f-86d191da78e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b96a-7647-b54f-86d191da78e6",
        "storage_key": "property/6767906449166401/019d02c7-b96a-7647-b54f-86d191da78e6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDTf8ajV2bIcRCRtw20wTHMQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_a23002e5-6a7c-469c-a7f3-c3403dba2012",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Butterfly Pavilion",
      "poi_type": "Entertainment",
      "poi_address": "6252 W 104th Ave, Westminster, CO 80020, USA",
      "poi_short_description": "Educational zoo featuring tropical butterflies, spiders and tarantulas.",
      "poi_long_description": "Visitors say this zoo offers a magical experience with thousands of butterflies flying freely in a tropical rainforest setting, plus interactive exhibits featuring tarantulas, starfish, and a play area. They also highlight the friendly and knowledgeable staff who enhance the educational value of the visit.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-904b-723a-bee5-783036b5cfee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-904b-723a-bee5-783036b5cfee",
        "storage_key": "property/6767906449166401/019d02c7-904b-723a-bee5-783036b5cfee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.butterflies.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10460704098384178030&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "butterfly-pavilion",
      "poi_latitude": "39.8873108",
      "poi_longitude": "-105.0666409",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 303-469-5441",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b96a-7647-b54f-86d191da78e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b96a-7647-b54f-86d191da78e6",
        "storage_key": "property/6767906449166401/019d02c7-b96a-7647-b54f-86d191da78e6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ34zTb4iJa4cRbmupTPTiK5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_de9056ae-c386-498b-ad60-5301437b437a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Boondocks Food and Fun - Northglenn",
      "poi_type": "Entertainment",
      "poi_address": "11425 Community Center Dr, Northglenn, CO 80233, USA",
      "poi_short_description": "Outdoor go-karting, bowling and laser tag destination, plus an arcade and a snack bar.",
      "poi_long_description": "People say this amusement park offers a wide variety of activities, including go-karts, mini golf, bowling, laser tag, and an arcade. They also highlight the reasonable prices, especially with the 4-hour unlimited pass, and the fun, energetic vibe.\n\nOther reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-9080-7263-9d67-cc94b7cb47b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-9080-7263-9d67-cc94b7cb47b1",
        "storage_key": "property/6767906449166401/019d02c7-9080-7263-9d67-cc94b7cb47b1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://boondocks.com/northglenn/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6059841461418448926&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "boondocks-food-and-fun---northglenn",
      "poi_latitude": "39.9035161",
      "poi_longitude": "-104.9883484",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 720-977-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b96a-7647-b54f-86d191da78e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b96a-7647-b54f-86d191da78e6",
        "storage_key": "property/6767906449166401/019d02c7-b96a-7647-b54f-86d191da78e6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ60MCidR1bIcRHtgH57PhGFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_ef10f411-6c08-4ac8-b9ae-a7dd01bcbeec",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Five Star Stadium",
      "poi_type": "Entertainment",
      "poi_address": "9351 Washington St, Thornton, CO 80229, USA",
      "poi_short_description": "Venue featuring a stadium and a track, good for kids.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-91dc-74a8-ab72-4cb37cb9aab2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-91dc-74a8-ab72-4cb37cb9aab2",
        "storage_key": "property/6767906449166401/019d02c7-91dc-74a8-ab72-4cb37cb9aab2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.adams12.org/resources/athletics-activities/athletic-facilities/five-star-stadium",
      "poi_directions_map_url": "https://maps.google.com/?cid=3884291144769299504&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "five-star-stadium",
      "poi_latitude": "39.8651331",
      "poi_longitude": "-104.9790306",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 720-972-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b96e-7487-b6a0-859c597fa61c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b96e-7487-b6a0-859c597fa61c",
        "storage_key": "property/6767906449166401/019d02c7-b96e-7487-b6a0-859c597fa61c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmQ4id_t2bIcRMGQrYDfG5zU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_f6fd18af-8d74-47ab-8f2d-d52dfdbc5e57",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "North Stadium",
      "poi_type": "Entertainment",
      "poi_address": "12500 Delaware Dr, Westminster, CO 80234, USA",
      "poi_short_description": "Big facility offering a stadium for football and track meets, plus other games and events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-94f4-7589-a07b-b1b09471691e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-94f4-7589-a07b-b1b09471691e",
        "storage_key": "property/6767906449166401/019d02c7-94f4-7589-a07b-b1b09471691e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8409091571216434570&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "north-stadium",
      "poi_latitude": "39.9238979",
      "poi_longitude": "-104.9891657",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 720-972-6536",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b96e-7487-b6a0-859c597fa61c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b96e-7487-b6a0-859c597fa61c",
        "storage_key": "property/6767906449166401/019d02c7-b96e-7487-b6a0-859c597fa61c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_6iVebR1bIcRikUWEjsYs3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_af62f981-7528-45a2-97c9-abb8cfa48a67",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "397 W 148th Ave, Westminster, CO 80023, USA",
      "poi_short_description": "Athletic country club offering fitness classes, indoor and outdoor pools, rock climbing, and more.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-9540-7648-a6e0-1d4e3f28473f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-9540-7648-a6e0-1d4e3f28473f",
        "storage_key": "property/6767906449166401/019d02c7-9540-7648-a6e0-1d4e3f28473f.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/co/westminster.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=3518828207938372099&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "39.9655614",
      "poi_longitude": "-104.9905472",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 303-429-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b96a-7647-b54f-86d191da78e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b96a-7647-b54f-86d191da78e6",
        "storage_key": "property/6767906449166401/019d02c7-b96a-7647-b54f-86d191da78e6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb8ZVnCZ1bIcRA4LKj5xj1TA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b4234418-845a-4f2c-adc0-603a571a2627",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "12900 Zuni St, Westminster, CO 80234, USA",
      "poi_short_description": "Cozy gym with welcoming staff, clean equipment and an indoor pool, plus a basketball court and a sauna.",
      "poi_long_description": "People say this gym offers a wide variety of studio classes, including yoga, HIIT, and barre, as well as amenities like a sauna, massage chairs, and kid care. They also highlight the affordable membership options, the spacious layout with plenty of equipment, and the friendly and helpful staff.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-96eb-707d-a0bc-02f5d040622d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-96eb-707d-a0bc-02f5d040622d",
        "storage_key": "property/6767906449166401/019d02c7-96eb-707d-a0bc-02f5d040622d.webp",
        "width": 1199,
        "height": 960
      },
      "poi_business_url": "https://vasafitness.com/locations/co/westminster-zuni/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16263478784794152960&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "39.9302801",
      "poi_longitude": "-105.0134626",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 720-506-3434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b96a-7647-b54f-86d191da78e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b96a-7647-b54f-86d191da78e6",
        "storage_key": "property/6767906449166401/019d02c7-b96a-7647-b54f-86d191da78e6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9wQHhuZ1bIcRANDBg8l7s-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ceed2c4a-e659-439d-920e-f163231e9ccf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Chuze Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "650 E 102nd Ave, Thornton, CO 80229, USA",
      "poi_short_description": "Friendly gym offering free weights, classes (including Zumba and yoga), hot tubs, pools, saunas, and steam rooms.",
      "poi_long_description": "People say this fitness center offers a wide variety of machines, a cardio theater, and wet and dry saunas. They highlight the reasonable price, clean facilities, and positive, welcoming atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-9ab9-711d-8764-c2e14372c9cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-9ab9-711d-8764-c2e14372c9cb",
        "storage_key": "property/6767906449166401/019d02c7-9ab9-711d-8764-c2e14372c9cb.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://chuzefitness.com/gym-locations/co/thornton/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6087139826515398911&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chuze-fitness",
      "poi_latitude": "39.8802528",
      "poi_longitude": "-104.9794921",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 720-548-5091",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b96a-7647-b54f-86d191da78e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b96a-7647-b54f-86d191da78e6",
        "storage_key": "property/6767906449166401/019d02c7-b96a-7647-b54f-86d191da78e6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1xH8wIx2bIcR_1CV0WvdeVQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_b36614c5-fdb1-404b-8f07-d2661ea19fd3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Gold's Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "550 Thornton Pkwy #210, Thornton, CO 80229, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a great selection of equipment, including smooth Matrix machines, and has a sauna. They also highlight the clean facilities, friendly staff, and 24-hour access.\n\nOther reviews mention the equipment can be moved around frequently.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-9d07-766b-bf19-87ed39c31bed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-9d07-766b-bf19-87ed39c31bed",
        "storage_key": "property/6767906449166401/019d02c7-9d07-766b-bf19-87ed39c31bed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.goldsgym.com/thornton-co/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13276436431757419871&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golds-gym",
      "poi_latitude": "39.8695265",
      "poi_longitude": "-104.9805805",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 720-667-1727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b96a-7647-b54f-86d191da78e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b96a-7647-b54f-86d191da78e6",
        "storage_key": "property/6767906449166401/019d02c7-b96a-7647-b54f-86d191da78e6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj-u_Nd93bIcRX6X01ZdgP7g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_833bc4e0-fe32-4711-ac60-b49e321182a5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "880 E 104th Ave, Thornton, CO 80233, USA",
      "poi_short_description": "Locker-equipped gym offering hydro massage and tanning beds, plus stair-climbing machines.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and amenities, including massage chairs and showers. They also highlight the clean facilities, friendly and helpful staff, and welcoming atmosphere.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-99d5-7657-a2a7-92314b55e47c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-99d5-7657-a2a7-92314b55e47c",
        "storage_key": "property/6767906449166401/019d02c7-99d5-7657-a2a7-92314b55e47c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/thornton-co?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=15630069853387597298&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "39.8836853",
      "poi_longitude": "-104.9746312",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 303-452-4426",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b96a-7647-b54f-86d191da78e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b96a-7647-b54f-86d191da78e6",
        "storage_key": "property/6767906449166401/019d02c7-b96a-7647-b54f-86d191da78e6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMx09CpJ2bIcR8qW1Ubgp6dg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b60da552-8547-4d78-8c61-c866bae9c103",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Milano Nail Spa - Walnut Creek - Nail salon Westminster Broomfield CO",
      "poi_type": "Health and Wellness",
      "poi_address": "10436 Town Center Dr #300, Westminster, CO 80021, USA",
      "poi_short_description": "Modern boutique beauty salon that specializes in manicures and pedicures, with other options such as waxing, facial and eyelash services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-9f86-772b-9589-9a6e2263b6d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-9f86-772b-9589-9a6e2263b6d6",
        "storage_key": "property/6767906449166401/019d02c7-9f86-772b-9589-9a6e2263b6d6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.milanonailspawalnutcreek.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13624736734652084030&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "milano-nail-spa---walnut-creek---nail-salon-westminster-broomfield-co",
      "poi_latitude": "39.8871928",
      "poi_longitude": "-105.0750157",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 720-899-4344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b96a-7647-b54f-86d191da78e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b96a-7647-b54f-86d191da78e6",
        "storage_key": "property/6767906449166401/019d02c7-b96a-7647-b54f-86d191da78e6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt9JasuiJa4cRPi8ni9_JFL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_d0672558-2891-4c9a-bffe-63f0a113fe73",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "CommonSpirit St. Anthony North Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "14300 Orchard Pkwy, Westminster, CO 80023, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-a059-736d-af21-60aa5b4a5f54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-a059-736d-af21-60aa5b4a5f54",
        "storage_key": "property/6767906449166401/019d02c7-a059-736d-af21-60aa5b4a5f54.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mountain.commonspirit.org/location/st-anthony-north-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=825369710359015077&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "commonspirit-st-anthony-north-hospital",
      "poi_latitude": "39.95573539999999",
      "poi_longitude": "-104.9913554",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 720-627-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b974-757a-9451-4368927f7aba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b974-757a-9451-4368927f7aba",
        "storage_key": "property/6767906449166401/019d02c7-b974-757a-9451-4368927f7aba.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJjYBO1B51bIcRpe5Q6mBNdAs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_363d726b-361e-4746-a7e9-d23a27d58cfd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "HCA HealthONE Mountain Ridge",
      "poi_type": "Health and Wellness",
      "poi_address": "9191 Grant St, Thornton, CO 80229, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-a216-753e-a86d-24e3ff278e5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-a216-753e-a86d-24e3ff278e5c",
        "storage_key": "property/6767906449166401/019d02c7-a216-753e-a86d-24e3ff278e5c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.healthonecares.com/locations/mountain-ridge?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=9336226679698799622&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hca-healthone-mountain-ridge",
      "poi_latitude": "39.8631925",
      "poi_longitude": "-104.9849814",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 303-451-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b974-757a-9451-4368927f7aba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b974-757a-9451-4368927f7aba",
        "storage_key": "property/6767906449166401/019d02c7-b974-757a-9451-4368927f7aba.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJfRvurfh2bIcRBrz4IbPwkIE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0f83b65c-f00a-44d6-af76-071506079fa5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Hyland Hills Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9650 Sheridan Boulevard, Westminster, CO 80031, USA",
      "poi_short_description": "Golf course offering a par 3 course and a Blue course, plus a pro shop, and a scholarship fund.",
      "poi_long_description": "Golfers say this golf course offers four courses, including an 18-hole gold course, a 9-hole blue course, and two par 3 courses, with well-kept grounds and ongoing improvements. They also highlight the friendly and professional staff, reasonable prices, and easy tee times.\n\nSome reviews mention the communication from staff can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-a331-775c-bbf2-62568c46bfd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-a331-775c-bbf2-62568c46bfd4",
        "storage_key": "property/6767906449166401/019d02c7-a331-775c-bbf2-62568c46bfd4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.golfhylandhills.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9787230036463521676&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hyland-hills-golf-course",
      "poi_latitude": "39.8702981",
      "poi_longitude": "-105.0506664",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 303-428-6526",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b966-707e-9e91-317c9c2967dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b966-707e-9e91-317c9c2967dd",
        "storage_key": "property/6767906449166401/019d02c7-b966-707e-9e91-317c9c2967dd.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ21wo5cGJa4cRjA9x-tw504c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_ed084225-94a4-40fe-a58e-b0a893d11b42",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Legacy Ridge Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10801 Legacy Ridge Pkwy, Westminster, CO 80031, USA",
      "poi_short_description": "Well-maintained course featuring a clubhouse and cart rentals, plus views of the mountains.",
      "poi_long_description": "People say this golf course has fast and true greens. They also highlight the amazing mountain views, well-maintained putting green, and excellent food and service.\n\nOther reviews mention the course can be challenging.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-a41f-703e-9fb5-9cef6c6c9724.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-a41f-703e-9fb5-9cef6c6c9724",
        "storage_key": "property/6767906449166401/019d02c7-a41f-703e-9fb5-9cef6c6c9724.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cityofwestminster.us/ParksRecreation/GolfWestminster/LegacyRidgeGolfCourse",
      "poi_directions_map_url": "https://maps.google.com/?cid=17255583039408162001&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "legacy-ridge-golf-course",
      "poi_latitude": "39.8923349",
      "poi_longitude": "-105.0358435",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 303-438-8997",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b966-707e-9e91-317c9c2967dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b966-707e-9e91-317c9c2967dd",
        "storage_key": "property/6767906449166401/019d02c7-b966-707e-9e91-317c9c2967dd.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJn_ZTcv-Ja4cR0cQtsFkleO8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_7b73e683-3ca1-460a-a6b7-ea423448cf3d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Carpenter Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3498 E 112th Ave, Thornton, CO 80233, USA",
      "poi_short_description": "Outdoor amusement park for toddlers, kids and adults [featuring fountains, a playground and a skate park.",
      "poi_long_description": "People say this park offers a carousel, splash pad, playground, walking paths, and a fishing lake. They highlight the ample parking, accessible facilities, and shady picnic areas. They also like the fun and engaging atmosphere for children of all ages. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-a53e-718e-945b-46a49ee5666d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-a53e-718e-945b-46a49ee5666d",
        "storage_key": "property/6767906449166401/019d02c7-a53e-718e-945b-46a49ee5666d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cityofthornton.net/recreation/facilities/Pages/carpenter-park.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6800990290414187977&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "carpenter-park",
      "poi_latitude": "39.8985111",
      "poi_longitude": "-104.9454742",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-bd72-759e-a3db-3fc1d3c7e9e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bd72-759e-a3db-3fc1d3c7e9e1",
        "storage_key": "property/6767906449166401/019d02c7-bd72-759e-a3db-3fc1d3c7e9e1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJV_9gxq52bIcRybUEzaL4YV4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_651ed586-c589-40f8-a330-7a3cc62e86fb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Broomfield Commons Sports Fields",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13200 Sheridan Boulevard, Broomfield, CO 80020, USA",
      "poi_short_description": "Well-maintained sports fields, children's play area, dog-friendly, and hiking paths.",
      "poi_long_description": "Visitors say this park has lots of soccer fields, open space to run, a dog park, and playground equipment. They also highlight the clean restrooms and facilities, plentiful parking, and picnic tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-a6b4-757b-9af3-1b6757b2d0ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-a6b4-757b-9af3-1b6757b2d0ad",
        "storage_key": "property/6767906449166401/019d02c7-a6b4-757b-9af3-1b6757b2d0ad.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.broomfield.org/Facilities/Facility/Details/9",
      "poi_directions_map_url": "https://maps.google.com/?cid=6068297623739283923&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "broomfield-commons-sports-fields",
      "poi_latitude": "39.9357541",
      "poi_longitude": "-105.0489984",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 303-469-3301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-bd72-759e-a3db-3fc1d3c7e9e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bd72-759e-a3db-3fc1d3c7e9e1",
        "storage_key": "property/6767906449166401/019d02c7-bd72-759e-a3db-3fc1d3c7e9e1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvSHh04uKa4cR07lTnonsNlQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2d5196e5-3510-4bf9-8b1e-ec3aed595d62",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Westminster Station Nature Play Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "R0100012, Denver, CO 80221, USA",
      "poi_short_description": "Shady city park with a splash pad, waterfall and sand pit, plus picnic spots.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-a80c-7178-8360-0358937a7147.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-a80c-7178-8360-0358937a7147",
        "storage_key": "property/6767906449166401/019d02c7-a80c-7178-8360-0358937a7147.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.westminsterco.gov/Facilities/Facility/Details/Westminster-Station-Park-Nature-Playgrou-67",
      "poi_directions_map_url": "https://maps.google.com/?cid=3984400568681875139&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westminster-station-nature-play-park",
      "poi_latitude": "39.8231883",
      "poi_longitude": "-105.0339631",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 303-658-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-bd72-759e-a3db-3fc1d3c7e9e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bd72-759e-a3db-3fc1d3c7e9e1",
        "storage_key": "property/6767906449166401/019d02c7-bd72-759e-a3db-3fc1d3c7e9e1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjUHW_12Ja4cRw8Yl-zRvSzc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b3e08b89-65ba-48e9-834d-0de8834e6097",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Thornton Crossroads & 104th Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Thornton, CO 80229, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-a8b8-709e-9f3f-3c3d74fc0de2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-a8b8-709e-9f3f-3c3d74fc0de2",
        "storage_key": "property/6767906449166401/019d02c7-a8b8-709e-9f3f-3c3d74fc0de2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11691032032429688047&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "thornton-crossroads--104th-station",
      "poi_latitude": "39.88213289999999",
      "poi_longitude": "-104.9423843",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-bd74-74aa-aa1f-a909cb36f502.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bd74-74aa-aa1f-a909cb36f502",
        "storage_key": "property/6767906449166401/019d02c7-bd74-74aa-aa1f-a909cb36f502.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJX_JGEMt2bIcR70SvFrHjPqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_8e325fc6-2d8a-48d3-8d47-270e98fc2f70",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Maxar",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1300 W 120th Ave, Westminster, CO 80234, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-aac7-76b4-ab83-efcc53b23c69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-aac7-76b4-ab83-efcc53b23c69",
        "storage_key": "property/6767906449166401/019d02c7-aac7-76b4-ab83-efcc53b23c69.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.maxar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16060976025028773410&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "maxar",
      "poi_latitude": "39.912559",
      "poi_longitude": "-105.0018364",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-684-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b96a-7647-b54f-86d191da78e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b96a-7647-b54f-86d191da78e6",
        "storage_key": "property/6767906449166401/019d02c7-b96a-7647-b54f-86d191da78e6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ77IjaMR1bIcRIsbnnZkM5N4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_8197600c-92c2-4aff-a9a5-49381cd79dfc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Google Thornton",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12396 Grant St, Thornton, CO 80241, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-ac03-778f-a591-64ddc81f0401.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-ac03-778f-a591-64ddc81f0401",
        "storage_key": "property/6767906449166401/019d02c7-ac03-778f-a591-64ddc81f0401.webp",
        "width": 1280,
        "height": 933
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4820801220169075958&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "google-thornton",
      "poi_latitude": "39.9223828",
      "poi_longitude": "-104.9833658",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b96a-7647-b54f-86d191da78e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b96a-7647-b54f-86d191da78e6",
        "storage_key": "property/6767906449166401/019d02c7-b96a-7647-b54f-86d191da78e6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJndouHUt0bIcR9ozyBCvt5kI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4a8ae5e1-b948-42f9-ba42-d5fd28abd1c6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "City of Northglenn",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11701 Community Center Dr, Northglenn, CO 80233, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-ad99-767e-b28e-012311bfc96c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-ad99-767e-b28e-012311bfc96c",
        "storage_key": "property/6767906449166401/019d02c7-ad99-767e-b28e-012311bfc96c.webp",
        "width": 800,
        "height": 525
      },
      "poi_business_url": "http://www.northglenn.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4424669227719312416&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-northglenn",
      "poi_latitude": "39.9096156",
      "poi_longitude": "-104.9873625",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 303-451-8326",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-bd76-7276-82a1-bb2090199b1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bd76-7276-82a1-bb2090199b1c",
        "storage_key": "property/6767906449166401/019d02c7-bd76-7276-82a1-bb2090199b1c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJZGzn811bIcRIMTPPjiVZz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_1d5cced0-9fec-46c7-8716-ff3e52ef3dc7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Forge Nano",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12300 Grant St #110, Thornton, CO 80241, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-adb5-7079-a8e4-3ff5081d01ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-adb5-7079-a8e4-3ff5081d01ff",
        "storage_key": "property/6767906449166401/019d02c7-adb5-7079-a8e4-3ff5081d01ff.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.forgenano.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10727120298226394537&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "forge-nano",
      "poi_latitude": "39.9201278",
      "poi_longitude": "-104.9839553",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 720-259-8579",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b96a-7647-b54f-86d191da78e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b96a-7647-b54f-86d191da78e6",
        "storage_key": "property/6767906449166401/019d02c7-b96a-7647-b54f-86d191da78e6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRxU3Vibza4cRqaWqlhNj3pQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_07498d86-6a33-447b-bb52-5bed221137db",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "poi_name": "Epicurean Butter",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14902 Grant St Unit 110, Thornton, CO 80023, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b013-72a8-b599-d23e5b464645.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-b013-72a8-b599-d23e5b464645",
        "storage_key": "property/6767906449166401/019d02c7-b013-72a8-b599-d23e5b464645.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://www.epicureanbutter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1681605521589622943&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "epicurean-butter",
      "poi_latitude": "39.9667625",
      "poi_longitude": "-104.9804754",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-427-5527",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-b96a-7647-b54f-86d191da78e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b96a-7647-b54f-86d191da78e6",
        "storage_key": "property/6767906449166401/019d02c7-b96a-7647-b54f-86d191da78e6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIYzKBiV2bIcRn1iv9k9DVhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_32726859-d9c0-4765-a7b7-dd6d695b6ba6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d466f29c-8c18-4b35-89b2-5991051c0809",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d89149b8-89e8-4047-b21d-2695c06c0ebc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_51d6e93e-58fd-4df6-be3c-9210752a7e18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_191db964-d6d2-46d7-838d-0d6b67000170",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_23747c8c-0a74-46da-b5fa-dbb75150f1b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_a2ae7c3a-c323-4082-85d4-f7e98bed9607",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "day": "SUN",
      "open_time": "12:00",
      "close_time": "16:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_bf3b9638b1f61bda91254248",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "rating": "5",
      "name": "To the Beach",
      "text": "I've lived here @ Regatta  a few times since 2021, I moved to Jacksonville Florida a year ago but ended back here New Year's Day. I reached out ahead and spoke to Kristal, she informed me of what units were available in the location of the complex I wanted to be and promptly took care of what needed to be done so I could get home.\nKristal is a good egg so if you are looking for a decent community to live in with helpful people reach out to Kristal for excellent customer service, a friendly smile, and come find your new residence.\nThe maintenance guys are great as well. 💪",
      "date": "2025-06-12",
      "title": "false"
    },
    {
      "id": "ec_d5aa37aaf5e689a0031110b3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "rating": "5",
      "name": "Julie Johnston",
      "text": "Recently moved in here at Regatta.  Everybody on staff has been a pleasure to work with.  Mario is my maintenance man and he is always respectful, kind and so very efficient. Every request for assistance has been met with concern and solved right away, whether its package delivery or apartment repair.\nGood job everyone on staff! Thank you",
      "date": "2025-08-27",
      "title": "false"
    },
    {
      "id": "ec_53243c4787ae0027c07acc08",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "rating": "5",
      "name": "Christina Peterman",
      "text": "My daughter's and I were homeless for 6 months,  we applied and the first person  we talked with was Krystal.  She is so amazing  we are so happy that we got accepted here . It was my daughter's birthday gift and Christmas gift. Perfect timing.  Since we have been here in December we have been so happy being here.  Everything is perfect for us. The  Maintenance men do such a great job and are super friendly.  Everyone in the office are so amazing.  The staff here care a lot about the tenants who live here. We love the pool the movie theater   the gym, we are so blessed and honored to be  living here. I can also say that everyone here love to interact with my kids and that makes a really happy parent lol. THANK YOU FROM THE BOTTOM OF OUR HEARTS FOR HAVING SUCH A GREAT TEAM OF WORKERS.  THEY FEEL MORE LIKE FAMILY TO US. IM WRITING THIS WITH TEARS IN MY EYES YALL HAVE NO IDEA HOW MUCH THIS PLACE MEANS TO US. WITH MUCH LOVE SINCERELY CHRISTINA PETERMAN AND THE GIRLS 🥰😍",
      "date": "2025-08-22",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_3bc428c2-c097-47d5-a8c6-700943a8e106",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019f602a-4c01-7013-b4c4-98779ac93bac.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f602a-4c01-7013-b4c4-98779ac93bac",
        "storage_key": "property/6767906449166401/019f602a-4c01-7013-b4c4-98779ac93bac.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=GgWGUoJ7qt8"
    },
    {
      "id": "custom_f09af98d-c257-4c4d-a71a-9a10ab4b078b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c8-33b6-72f8-83a9-eb1ae58f6c22.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "View of a spacious living area and kitchen island with sink and faucet.",
        "public_id": "019d02c8-33b6-72f8-83a9-eb1ae58f6c22",
        "storage_key": "property/6767906449166401/019d02c8-33b6-72f8-83a9-eb1ae58f6c22.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "1BR, 1BA - Florence",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=J4gPygQwqVH"
    },
    {
      "id": "custom_8fd510ef-4c1d-44eb-864d-bd819a3055e7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c8-a291-73ec-8c31-2f9e901bc88c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with fireplace and kitchen visible",
        "public_id": "019d02c8-a291-73ec-8c31-2f9e901bc88c",
        "storage_key": "property/6767906449166401/019d02c8-a291-73ec-8c31-2f9e901bc88c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - Venice",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=PSwY898QkSS"
    },
    {
      "id": "custom_da52a050-c2ce-479f-8bb2-9fb3cc75c153",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019f602a-5ab3-71dc-8aa9-04f41b9418ca.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f602a-5ab3-71dc-8aa9-04f41b9418ca",
        "storage_key": "property/6767906449166401/019f602a-5ab3-71dc-8aa9-04f41b9418ca.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Cannes - 2BR, 1BA - 903SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=eJiNcv5doGL"
    },
    {
      "id": "custom_28ba2c40-742b-4259-aed1-7bb182c35a91",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c8-ac52-7449-b89c-eb03ed35385d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with fireplace and large windows",
        "public_id": "019d02c8-ac52-7449-b89c-eb03ed35385d",
        "storage_key": "property/6767906449166401/019d02c8-ac52-7449-b89c-eb03ed35385d.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "2BR, 2BA - Marseilles/1028SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=jepfqpAn6Tw"
    },
    {
      "id": "custom_2dfdd7f5-8acf-4379-91bc-32f7cbcd4924",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c8-3e96-73f7-83f2-d285f7756fc6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with fireplace and view of kitchen and entryway.",
        "public_id": "019d02c8-3e96-73f7-83f2-d285f7756fc6",
        "storage_key": "property/6767906449166401/019d02c8-3e96-73f7-83f2-d285f7756fc6.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "3BR, 2BA - Verseille",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Fv6uvQWj9R4"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_6fa4ffc0bb39c8a90cf9513f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "aim",
      "external_id": "OTHER:MLRI:General Liability:Monthly:During Term",
      "name": "General Liability",
      "description": "false",
      "amount": 13,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "Other",
      "charge_code": "MLRI",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_d7ca723ed7bd4279c1c92824",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "aim",
      "external_id": "SERVICE:UBT:Trash:Monthly:During Term",
      "name": "Trash",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Variable",
      "amount_type": "text",
      "timing": "Monthly",
      "category": "Service",
      "charge_code": "UBT",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_0d14e976e5985187de9db3f4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "aim",
      "external_id": "UTILITY:UBG:Gas:Monthly:During Term",
      "name": "Gas",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Variable",
      "amount_type": "text",
      "timing": "Monthly",
      "category": "Utility",
      "charge_code": "UBG",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_17291dafecf4d0d1f7dd6c6c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "aim",
      "external_id": "UTILITY:UBS:Sewer:Monthly:During Term",
      "name": "Sewer",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Variable",
      "amount_type": "text",
      "timing": "Monthly",
      "category": "Utility",
      "charge_code": "UBS",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_295b465e764c4ef5bd0af8f3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "aim",
      "external_id": "UTILITY:UBW:Water:Monthly:During Term",
      "name": "Water",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Variable",
      "amount_type": "text",
      "timing": "Monthly",
      "category": "Utility",
      "charge_code": "UBW",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_d5d5a63f26ee387c423ac585",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "aim",
      "external_id": "UTILITY:UTIL:UB West Billing Fee:Monthly:During Term",
      "name": "UB West Billing Fee",
      "description": "false",
      "amount": 6,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "Utility",
      "charge_code": "UTIL",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019990e7-f953-74e6-ac18-f8647f20246c",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-regatta",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "page_item_url": "northglenn-co-apartments-with-pool",
      "search_query": "apartments with pool Northglenn CO",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Northglenn, CO",
      "h2_subtitle": "Discover Regatta, Northglenn’s choice for apartments with a pool. Enjoy a modern living experience combined with deluxe amenities at our premier location.",
      "page_copy": "Experience unparalleled comfort and convenience at Regatta, featuring the best apartments with pool Northglenn CO has to offer. Our stunning resort-style pool provides a perfect retreat for relaxation and leisure. Nestled in Northglenn, CO, Regatta offers a vibrant community with one, two, and three-bedroom apartment options perfect for any lifestyle.\n\nIn addition to the inviting swimming pool, residents at Regatta enjoy top-notch amenities such as a state-of-the-art fitness center, scenic walking trails, and secure living with our cutting-edge security system. Immerse yourself in the ideal blend of modern design and peaceful living. Visit today and find your dream apartment in Northglenn, CO.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d02c7-322f-71dd-a7ad-9a0f9e41b382",
        "storage_key": "property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Northglenn, CO",
      "seo_description": "Explore Regatta with a resort-style pool in Northglenn, CO. Discover premium apartment living today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "page_item_url": "adams-county-dog-friendly-apartments",
      "search_query": "dog friendly apartments Adams County",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments in Adams County",
      "h2_subtitle": "Discover Regatta, the ideal dog-friendly apartments in Adams County. Enjoy pet-friendly amenities and spacious living in Northglenn, CO.",
      "page_copy": "Welcome to Regatta, where you and your furry friend are warmly embraced at our dog friendly apartments in Adams County. Located in the vibrant area of Northglenn, CO, our community offers the perfect setting for you and your pet. Choose from our one, two, or three-bedroom plans, each designed with modern comforts in mind.\n\nOur pet-loving community also boasts a range of amenities, including scenic walking trails that are perfect for daily strolls. Beyond being dog-friendly, residents enjoy a resort-style pool, fitness center, and security system to ensure a comfortable lifestyle. Visit Regatta today and discover your perfect home in a pet-friendly environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d02c7-322f-71dd-a7ad-9a0f9e41b382",
        "storage_key": "property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments in Adams County",
      "seo_description": "Live at Regatta: dog-friendly apartments in Adams County. Enjoy pet-friendly living in Northglenn, CO!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "page_item_url": "80233-luxury-apartments-fitness-center",
      "search_query": "luxury apartments with fitness center 80233",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Fitness Center, 80233",
      "h2_subtitle": "Elevate your lifestyle at Regatta, featuring luxury apartments with a state-of-the-art fitness center in the 80233 area.",
      "page_copy": "Discover the epitome of luxury living at Regatta, offering spectacular luxury apartments with fitness center in the heart of the 80233 area. Our Northglenn, CO community is perfect for those seeking a blend of style and convenience. Choose from our spacious one, two, or three-bedroom apartment options designed with high-end finishes and modern amenities.\n\nResidents enjoy access to our top-notch fitness center, perfect for maintaining an active, healthy lifestyle without leaving home. Alongside the cutting-edge fitness facilities, Regatta offers a resort-style pool, secure living with modern security systems, and beautiful walking trails. Experience the charm and convenience of luxury living at Regatta today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d02c7-322f-71dd-a7ad-9a0f9e41b382",
        "storage_key": "property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Fitness Center, 80233",
      "seo_description": "Regatta offers luxury apartments with a fitness center in the 80233 zip code. Experience premium living in Northglenn, CO.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "page_item_url": "northglenn-apartments-air-conditioning",
      "search_query": "apartments with air conditioning Northglenn",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning, Northglenn",
      "h2_subtitle": "Discover comfort at Regatta's Northglenn apartments with air conditioning. Enjoy modern living with climate-controlled comfort.",
      "page_copy": "Welcome to Regatta, your destination for comfortable living with our apartments that feature air conditioning in Northglenn. Each of our one, two, or three-bedroom units is designed to enhance your living experience with modern comforts, including efficient climate control to ensure year-round comfort.\n\nAt Regatta, you’ll find more than just cooling features. Enjoy our resort-style amenities such as an inviting pool, a well-equipped fitness center, and scenic walking trails. With our advanced security systems and pet-friendly policies, you'll find everything needed for a convenient and relaxed lifestyle. Visit Regatta today and experience the benefits of Northglenn living with air-conditioned comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d02c7-322f-71dd-a7ad-9a0f9e41b382",
        "storage_key": "property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Air Conditioning, Northglenn",
      "seo_description": "Regatta offers Northglenn apartments with air conditioning for optimal comfort. Discover modern living in our climate-controlled spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "page_item_url": "adams-county-apartment-in-unit-laundry",
      "search_query": "apartment with in-unit washer/dryer in Adams County",
      "category": "Amenity",
      "h1_title": "Apartment with In-Unit Washer/Dryer, Adams County",
      "h2_subtitle": "Enjoy the convenience of in-unit laundry at Regatta's Adams County apartments. Experience modern living with premium amenities in Northglenn, CO.",
      "page_copy": "Explore the ultimate convenience at Regatta, where each apartment features an in-unit washer/dryer in the heart of Adams County. Perfectly situated in Northglenn, CO, our community offers a superb selection of one, two, and three-bedroom apartments designed to simplify your daily routine.\n\nOur luxurious amenities ensure an elevated lifestyle, from a state-of-the-art fitness center to a resort-style pool and scenic walking trails. With added conveniences like a secure living environment, bay windows, and spacious family rooms, Regatta is the ideal place for modern, hassle-free living. Join our community and experience the comfort of having an in-unit washer/dryer today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d02c7-322f-71dd-a7ad-9a0f9e41b382",
        "storage_key": "property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment with In-Unit Washer/Dryer, Adams County",
      "seo_description": "Regatta offers apartments with in-unit washer/dryer in Adams County, CO. Enjoy convenient living in Northglenn!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "page_item_url": "northglenn-co-1-bedroom-apartments",
      "search_query": "1 bedroom apartments northglenn co",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments, Northglenn, CO",
      "h2_subtitle": "Discover Regatta's stylish 1 bedroom apartments in Northglenn, CO. Perfect for those seeking modern amenities and comfort in a prime location.",
      "page_copy": "Welcome to Regatta, where you'll find beautifully designed 1 bedroom apartments in Northglenn, CO, perfect for singles or couples looking for a cozy retreat. Each unit is thoughtfully crafted to offer both comfort and style, featuring modern finishes and ample living space.\n\nBeyond the stylish interiors, residents enjoy access to a range of luxurious amenities, including a resort-style pool, a state-of-the-art fitness center, and serene walking trails. With convenient locations near shopping, dining, and entertainment, Regatta offers a balanced lifestyle in a vibrant community. Explore our 1 bedroom apartments and experience the best of Northglenn living at Regatta today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d02c7-322f-71dd-a7ad-9a0f9e41b382",
        "storage_key": "property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments, Northglenn, CO",
      "seo_description": "Find modern 1 bedroom apartments in Northglenn, CO at Regatta. Enjoy luxurious amenities and a convenient location!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "page_item_url": "adams-county-2-bedroom-apartments",
      "search_query": "2 bedroom apartments adams county",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Adams County",
      "h2_subtitle": "Explore spacious 2 bedroom apartments at Regatta in Adams County. Enjoy modern living with exceptional amenities and a prime location in Northglenn, CO.",
      "page_copy": "Regatta invites you to discover our generous 2 bedroom apartments in Adams County, perfect for families or roommates. Each unit is thoughtfully designed with open living spaces, modern finishes, and all the conveniences necessary for comfortable living.\n\nOur Adams County community offers more than just spacious interiors. Take advantage of our luxurious amenities including a resort-style pool, cutting-edge fitness center, and scenic walking trails. Located in Northglenn, CO, Regatta places you in a vibrant neighborhood close to dining, shopping, and entertainment options. Step into the perfect balance of style and convenience by exploring our 2 bedroom apartments at Regatta.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d02c7-322f-71dd-a7ad-9a0f9e41b382",
        "storage_key": "property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Adams County",
      "seo_description": "Discover spacious 2 bedroom apartments in Adams County at Regatta. Enjoy luxury living with modern amenities in Northglenn, CO!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-near-80233",
      "search_query": "3 bedroom apartments near 80233",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments Near 80233",
      "h2_subtitle": "Find spacious 3 bedroom apartments at Regatta, near the 80233 area. Enjoy a community filled with modern amenities in Northglenn, CO.",
      "page_copy": "Discover the comfort and style of Regatta's expansive 3 bedroom apartments located conveniently near the 80233 area. Ideal for families seeking extra space, these homes offer contemporary designs and practical layouts tailored to enhance your living experience.\n\nAt Regatta, it's not just about the space—our community provides access to exceptional amenities including a resort-style pool, a well-equipped fitness center, and tranquil walking trails. Nestled in Northglenn, CO, just outside the bustling environment of the 80233 zip code, you’ll enjoy a perfect blend of suburban peace and access to local conveniences. Make Regatta your new home and relish in the premium living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d02c7-322f-71dd-a7ad-9a0f9e41b382",
        "storage_key": "property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Near 80233",
      "seo_description": "Explore spacious 3 bedroom apartments near the 80233 area at Regatta. Enjoy modern amenities in Northglenn, CO!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "page_item_url": "apartments-near-front-range-community-college",
      "search_query": "apartments near front range community college westminster co",
      "category": "School",
      "h1_title": "Apartments Near Front Range Community College",
      "h2_subtitle": "Discover ideal living at Regatta, with apartments near Front Range Community College, Westminster, CO. Enjoy modern amenities and convenient commutes.",
      "page_copy": "Regatta offers stylish living options just a short drive away from Front Range Community College in Westminster, CO. Our apartments provide an ideal choice for students and professionals who value convenience without compromising on quality.\n\nEnjoy the benefits of a vibrant community featuring luxurious amenities like a resort-style pool and a cutting-edge fitness center. Located in the heart of Northglenn, these apartments offer easy access to educational, dining, and entertainment options. Whether you're a student or faculty member, Regatta is the perfect place to call home, balancing education and lifestyle seamlessly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d02c7-322f-71dd-a7ad-9a0f9e41b382",
        "storage_key": "property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Front Range Community College",
      "seo_description": "Find convenient apartments near Front Range Community College in Westminster, CO at Regatta. Enjoy modern amenities and easy commutes!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "page_item_url": "apartments-near-variable-support-northglenn",
      "search_query": "apartments near Commonsense: Variable Support",
      "category": "Hospital",
      "h1_title": "Apartments Near Variable Support Facility",
      "h2_subtitle": "Explore Regatta's prime apartments near Commonsense: Variable Support in Northglenn, CO. Enjoy luxury living in a vibrant community.",
      "page_copy": "Regatta presents ideal living solutions with our modern apartments conveniently located near Commonsense: Variable Support in Northglenn, CO. Perfect for those who work at or visit the facility, our community combines accessibility with comfort.\n\nLive amidst luxurious amenities, including a resort-style pool, a fitness center, and picturesque walking trails. Each apartment is designed with your lifestyle in mind, offering spacious layouts and contemporary finishes. Nestled in Northglenn, Regatta places you near dining and entertainment options, enhancing your living experience with convenience and style.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d02c7-322f-71dd-a7ad-9a0f9e41b382",
        "storage_key": "property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Variable Support Facility",
      "seo_description": "Discover apartments near Commonsense: Variable Support in Northglenn, CO at Regatta. Enjoy luxury amenities and convenient access!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "page_item_url": "apartments-near-carpenter-park-northglenn",
      "search_query": "apartments near Carpenter Park Northglenn",
      "category": "Park",
      "h1_title": "Apartments Near Carpenter Park, Northglenn",
      "h2_subtitle": "Discover Regatta's apartments near Carpenter Park in Northglenn. Enjoy easy access to this local gem and fabulous community amenities.",
      "page_copy": "Nestled in Northglenn, Regatta offers exceptional apartment living just moments from the scenic Carpenter Park. Our apartments provide residents with easy access to lush green spaces, trails, and recreational activities—perfect for outdoor enthusiasts and families alike.\n\nThe community boasts a resort-style pool, a state-of-the-art fitness center, and relaxing walking trails. Our thoughtfully designed one, two, or three-bedroom apartments ensure you find the perfect fit for your lifestyle. Experience the best of Northglenn, where a vibrant community and convenience await you at Regatta, just a short stroll from Carpenter Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d02c7-322f-71dd-a7ad-9a0f9e41b382",
        "storage_key": "property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Carpenter Park, Northglenn",
      "seo_description": "Find stylish apartments near Carpenter Park in Northglenn at Regatta. Enjoy easy access to leisure activities and modern amenities!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "page_item_url": "apartments-close-to-broomfield-commons-sports-fields",
      "search_query": "apartments close to Broomfield Commons Sports Fields CO",
      "category": "Park",
      "h1_title": "Apartments Close to Broomfield Commons Fields",
      "h2_subtitle": "Find Regatta's apartments close to Broomfield Commons Sports Fields, CO. Enjoy proximity to sporting events and luxurious amenities.",
      "page_copy": "Regatta features modern and spacious apartments just a short drive from Broomfield Commons Sports Fields in Colorado. Ideal for sports enthusiasts and families, our location offers convenience and excitement close to your doorstep.\n\nOur community is equipped with top-tier amenities, including a resort-style pool and a comprehensive fitness center. Choose from our one, two, or three-bedroom apartments and relish in the combination of comfort and accessibility. Positioned in vibrant Northglenn, Regatta provides an excellent home base for exploring nearby recreational activities and sporting events, ensuring you're always at the heart of action.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d02c7-322f-71dd-a7ad-9a0f9e41b382",
        "storage_key": "property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Broomfield Commons Fields",
      "seo_description": "Discover Regatta's apartments close to Broomfield Commons Sports Fields, CO. Experience convenience and great amenities!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166401",
      "source": "generator",
      "page_item_url": "regatta-apartments-by-westminster-station-nature-play-park",
      "search_query": "Regatta apartments by Westminster Station Nature Play Park",
      "category": "Park",
      "h1_title": "Regatta Apartments by Nature Play Park",
      "h2_subtitle": "Explore Regatta apartments near Westminster Station Nature Play Park. Enjoy modern comforts and easy access to nature's playground in Northglenn.",
      "page_copy": "Discover Regatta, a premier apartment community located near Westminster Station Nature Play Park. Ideal for families and nature lovers, our location offers effortless access to outdoor adventures and natural beauty.\n\nChoose from a variety of floor plans, including one, two, and three-bedroom apartments, tailored to fit your lifestyle. Our community features luxurious amenities such as a resort-style pool and a contemporary fitness center. Living at Regatta means you’re close to nature while enjoying modern comforts, making it an excellent choice for a balanced lifestyle in Northglenn.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d02c7-322f-71dd-a7ad-9a0f9e41b382",
        "storage_key": "property/6767906449166401/019d02c7-322f-71dd-a7ad-9a0f9e41b382.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Regatta Apartments by Nature Play Park",
      "seo_description": "Find Regatta apartments near Westminster Station Nature Play Park. Enjoy luxury amenities and proximity to outdoor enjoyment!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "lindseye@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5245"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10083996914"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-N3WVXTGD"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Theme Conversion"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Avenue"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "377RTA"
    },
    {
      "ID": "custom_anyonehome_chatbot",
      "type": "STRING",
      "value": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('Mwa0bAqCswXiYVTfcE')</script>"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "5395499313"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "ER100107678"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Regatta/scheduletourwidget/ifLNSnccDR3IIGcyQi/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkNldllnc28vQjZQcjhmbGt6RFBtNWc9PSIsInZhbHVlIjoieW82SUkvWlN0NGlWNXNpdEI3WkhhUT09IiwibWFjIjoiMzc4MWJlODJlN2RjOTkzOTAwZDkzZTU2NDU3MmMxZDUyYWFhNGU3ZjBkMTViMTMzZjhiNWRhY2UyNjc0MDk0NyJ9"
    }
  ],
  "custom_csm": "lindseye@repli360.com",
  "custom_qb_id": "5245",
  "custom_repli_id": "10083996914",
  "custom_google_gtm_id": "GTM-N3WVXTGD",
  "custom_rollout_phase": "Theme Conversion",
  "custom_vibesites_theme": "Avenue",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "none",
  "custom_aim_property_code": "377RTA",
  "custom_anyonehome_chatbot": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('Mwa0bAqCswXiYVTfcE')</script>",
  "custom_hubspot_company_id": "5395499313",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_broker_license_number": "ER100107678",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Regatta/scheduletourwidget/ifLNSnccDR3IIGcyQi/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkNldllnc28vQjZQcjhmbGt6RFBtNWc9PSIsInZhbHVlIjoieW82SUkvWlN0NGlWNXNpdEI3WkhhUT09IiwibWFjIjoiMzc4MWJlODJlN2RjOTkzOTAwZDkzZTU2NDU3MmMxZDUyYWFhNGU3ZjBkMTViMTMzZjhiNWRhY2UyNjc0MDk0NyJ9",
  "custom_audioeye_site_id": "2e97b981-e465-4e28-982d-fe9c086df8b2",
  "custom_audioeye_site_hash": "41163e3efdf16a747c81f8f8e2137bfe"
};

export const generatedAt = '2026-10-14T20:31:14.951Z';
